module.exports = {
  "border": {
    "s": {
      "value": 1,
      "original": {
        "value": 1
      },
      "name": "BorderS",
      "attributes": {
        "category": "border",
        "type": "s"
      },
      "path": [
        "border",
        "s"
      ]
    },
    "m": {
      "value": 2,
      "original": {
        "value": 2
      },
      "name": "BorderM",
      "attributes": {
        "category": "border",
        "type": "m"
      },
      "path": [
        "border",
        "m"
      ]
    },
    "l": {
      "value": 3,
      "original": {
        "value": 3
      },
      "name": "BorderL",
      "attributes": {
        "category": "border",
        "type": "l"
      },
      "path": [
        "border",
        "l"
      ]
    }
  },
  "color": {
    "primary-01": {
      "100": {
        "value": "#eaf3e2",
        "original": {
          "value": "#EAF3E2"
        },
        "name": "ColorPrimary01100",
        "attributes": {
          "category": "color",
          "type": "primary-01",
          "item": "100"
        },
        "path": [
          "color",
          "primary-01",
          "100"
        ]
      },
      "200": {
        "value": "#cbe3b5",
        "original": {
          "value": "#CBE3B5"
        },
        "name": "ColorPrimary01200",
        "attributes": {
          "category": "color",
          "type": "primary-01",
          "item": "200"
        },
        "path": [
          "color",
          "primary-01",
          "200"
        ]
      },
      "300": {
        "value": "#add585",
        "original": {
          "value": "#ADD585"
        },
        "name": "ColorPrimary01300",
        "attributes": {
          "category": "color",
          "type": "primary-01",
          "item": "300"
        },
        "path": [
          "color",
          "primary-01",
          "300"
        ]
      },
      "400": {
        "value": "#91c854",
        "original": {
          "value": "#91C854"
        },
        "name": "ColorPrimary01400",
        "attributes": {
          "category": "color",
          "type": "primary-01",
          "item": "400"
        },
        "path": [
          "color",
          "primary-01",
          "400"
        ]
      },
      "500": {
        "value": "#78be20",
        "original": {
          "value": "#78BE20"
        },
        "name": "ColorPrimary01500",
        "attributes": {
          "category": "color",
          "type": "primary-01",
          "item": "500"
        },
        "path": [
          "color",
          "primary-01",
          "500"
        ]
      },
      "600": {
        "value": "#41a017",
        "original": {
          "value": "#41A017"
        },
        "name": "ColorPrimary01600",
        "attributes": {
          "category": "color",
          "type": "primary-01",
          "item": "600"
        },
        "path": [
          "color",
          "primary-01",
          "600"
        ]
      },
      "700": {
        "value": "#158110",
        "original": {
          "value": "#158110"
        },
        "name": "ColorPrimary01700",
        "attributes": {
          "category": "color",
          "type": "primary-01",
          "item": "700"
        },
        "path": [
          "color",
          "primary-01",
          "700"
        ]
      },
      "800": {
        "value": "#0a601b",
        "original": {
          "value": "#0A601B"
        },
        "name": "ColorPrimary01800",
        "attributes": {
          "category": "color",
          "type": "primary-01",
          "item": "800"
        },
        "path": [
          "color",
          "primary-01",
          "800"
        ]
      },
      "900": {
        "value": "#053e1f",
        "original": {
          "value": "#053E1F"
        },
        "name": "ColorPrimary01900",
        "attributes": {
          "category": "color",
          "type": "primary-01",
          "item": "900"
        },
        "path": [
          "color",
          "primary-01",
          "900"
        ]
      }
    },
    "primary-02": {
      "100": {
        "value": "#dbedea",
        "original": {
          "value": "#DBEDEA"
        },
        "name": "ColorPrimary02100",
        "attributes": {
          "category": "color",
          "type": "primary-02",
          "item": "100"
        },
        "path": [
          "color",
          "primary-02",
          "100"
        ]
      },
      "200": {
        "value": "#a5d1cb",
        "original": {
          "value": "#A5D1CB"
        },
        "name": "ColorPrimary02200",
        "attributes": {
          "category": "color",
          "type": "primary-02",
          "item": "200"
        },
        "path": [
          "color",
          "primary-02",
          "200"
        ]
      },
      "300": {
        "value": "#6eb4ad",
        "original": {
          "value": "#6EB4AD"
        },
        "name": "ColorPrimary02300",
        "attributes": {
          "category": "color",
          "type": "primary-02",
          "item": "300"
        },
        "path": [
          "color",
          "primary-02",
          "300"
        ]
      },
      "400": {
        "value": "#379590",
        "original": {
          "value": "#379590"
        },
        "name": "ColorPrimary02400",
        "attributes": {
          "category": "color",
          "type": "primary-02",
          "item": "400"
        },
        "path": [
          "color",
          "primary-02",
          "400"
        ]
      },
      "500": {
        "value": "#007574",
        "original": {
          "value": "#007574"
        },
        "name": "ColorPrimary02500",
        "attributes": {
          "category": "color",
          "type": "primary-02",
          "item": "500"
        },
        "path": [
          "color",
          "primary-02",
          "500"
        ]
      },
      "600": {
        "value": "#035f64",
        "original": {
          "value": "#035F64"
        },
        "name": "ColorPrimary02600",
        "attributes": {
          "category": "color",
          "type": "primary-02",
          "item": "600"
        },
        "path": [
          "color",
          "primary-02",
          "600"
        ]
      },
      "700": {
        "value": "#044c53",
        "original": {
          "value": "#044C53"
        },
        "name": "ColorPrimary02700",
        "attributes": {
          "category": "color",
          "type": "primary-02",
          "item": "700"
        },
        "path": [
          "color",
          "primary-02",
          "700"
        ]
      },
      "800": {
        "value": "#063a44",
        "original": {
          "value": "#063A44"
        },
        "name": "ColorPrimary02800",
        "attributes": {
          "category": "color",
          "type": "primary-02",
          "item": "800"
        },
        "path": [
          "color",
          "primary-02",
          "800"
        ]
      },
      "900": {
        "value": "#062b35",
        "original": {
          "value": "#062B35"
        },
        "name": "ColorPrimary02900",
        "attributes": {
          "category": "color",
          "type": "primary-02",
          "item": "900"
        },
        "path": [
          "color",
          "primary-02",
          "900"
        ]
      }
    },
    "grey": {
      "100": {
        "value": "#eeeef0",
        "original": {
          "value": "#EEEEF0"
        },
        "name": "ColorGrey100",
        "attributes": {
          "category": "color",
          "type": "grey",
          "item": "100"
        },
        "path": [
          "color",
          "grey",
          "100"
        ]
      },
      "200": {
        "value": "#d3d2d6",
        "original": {
          "value": "#D3D2D6"
        },
        "name": "ColorGrey200",
        "attributes": {
          "category": "color",
          "type": "grey",
          "item": "200"
        },
        "path": [
          "color",
          "grey",
          "200"
        ]
      },
      "300": {
        "value": "#bab6bc",
        "original": {
          "value": "#BAB6BC"
        },
        "name": "ColorGrey300",
        "attributes": {
          "category": "color",
          "type": "grey",
          "item": "300"
        },
        "path": [
          "color",
          "grey",
          "300"
        ]
      },
      "400": {
        "value": "#a19ba2",
        "original": {
          "value": "#A19BA2"
        },
        "name": "ColorGrey400",
        "attributes": {
          "category": "color",
          "type": "grey",
          "item": "400"
        },
        "path": [
          "color",
          "grey",
          "400"
        ]
      },
      "500": {
        "value": "#887f87",
        "original": {
          "value": "#887F87"
        },
        "name": "ColorGrey500",
        "attributes": {
          "category": "color",
          "type": "grey",
          "item": "500"
        },
        "path": [
          "color",
          "grey",
          "500"
        ]
      },
      "600": {
        "value": "#6f676c",
        "original": {
          "value": "#6F676C"
        },
        "name": "ColorGrey600",
        "attributes": {
          "category": "color",
          "type": "grey",
          "item": "600"
        },
        "path": [
          "color",
          "grey",
          "600"
        ]
      },
      "700": {
        "value": "#554f52",
        "original": {
          "value": "#554F52"
        },
        "name": "ColorGrey700",
        "attributes": {
          "category": "color",
          "type": "grey",
          "item": "700"
        },
        "path": [
          "color",
          "grey",
          "700"
        ]
      },
      "800": {
        "value": "#3c3738",
        "original": {
          "value": "#3C3738"
        },
        "name": "ColorGrey800",
        "attributes": {
          "category": "color",
          "type": "grey",
          "item": "800"
        },
        "path": [
          "color",
          "grey",
          "800"
        ]
      },
      "900": {
        "value": "#222020",
        "original": {
          "value": "#222020"
        },
        "name": "ColorGrey900",
        "attributes": {
          "category": "color",
          "type": "grey",
          "item": "900"
        },
        "path": [
          "color",
          "grey",
          "900"
        ]
      },
      "999": {
        "value": "#000000",
        "original": {
          "value": "#000000"
        },
        "name": "ColorGrey999",
        "attributes": {
          "category": "color",
          "type": "grey",
          "item": "999"
        },
        "path": [
          "color",
          "grey",
          "999"
        ]
      },
      "000": {
        "value": "#ffffff",
        "original": {
          "value": "#FFFFFF"
        },
        "name": "ColorGrey000",
        "attributes": {
          "category": "color",
          "type": "grey",
          "item": "000"
        },
        "path": [
          "color",
          "grey",
          "000"
        ]
      }
    },
    "secondary-blue": {
      "100": {
        "value": "#ecfcfd",
        "original": {
          "value": "#ECFCFD"
        },
        "name": "ColorSecondaryBlue100",
        "attributes": {
          "category": "color",
          "type": "secondary-blue",
          "item": "100"
        },
        "path": [
          "color",
          "secondary-blue",
          "100"
        ]
      },
      "200": {
        "value": "#b7eef5",
        "original": {
          "value": "#B7EEF5"
        },
        "name": "ColorSecondaryBlue200",
        "attributes": {
          "category": "color",
          "type": "secondary-blue",
          "item": "200"
        },
        "path": [
          "color",
          "secondary-blue",
          "200"
        ]
      },
      "300": {
        "value": "#84dbeb",
        "original": {
          "value": "#84DBEB"
        },
        "name": "ColorSecondaryBlue300",
        "attributes": {
          "category": "color",
          "type": "secondary-blue",
          "item": "300"
        },
        "path": [
          "color",
          "secondary-blue",
          "300"
        ]
      },
      "400": {
        "value": "#54c4de",
        "original": {
          "value": "#54C4DE"
        },
        "name": "ColorSecondaryBlue400",
        "attributes": {
          "category": "color",
          "type": "secondary-blue",
          "item": "400"
        },
        "path": [
          "color",
          "secondary-blue",
          "400"
        ]
      },
      "500": {
        "value": "#25a8d0",
        "original": {
          "value": "#25A8D0"
        },
        "name": "ColorSecondaryBlue500",
        "attributes": {
          "category": "color",
          "type": "secondary-blue",
          "item": "500"
        },
        "path": [
          "color",
          "secondary-blue",
          "500"
        ]
      },
      "600": {
        "value": "#2282a8",
        "original": {
          "value": "#2282A8"
        },
        "name": "ColorSecondaryBlue600",
        "attributes": {
          "category": "color",
          "type": "secondary-blue",
          "item": "600"
        },
        "path": [
          "color",
          "secondary-blue",
          "600"
        ]
      },
      "700": {
        "value": "#1e5f82",
        "original": {
          "value": "#1E5F82"
        },
        "name": "ColorSecondaryBlue700",
        "attributes": {
          "category": "color",
          "type": "secondary-blue",
          "item": "700"
        },
        "path": [
          "color",
          "secondary-blue",
          "700"
        ]
      },
      "800": {
        "value": "#18415d",
        "original": {
          "value": "#18415D"
        },
        "name": "ColorSecondaryBlue800",
        "attributes": {
          "category": "color",
          "type": "secondary-blue",
          "item": "800"
        },
        "path": [
          "color",
          "secondary-blue",
          "800"
        ]
      },
      "900": {
        "value": "#102739",
        "original": {
          "value": "#102739"
        },
        "name": "ColorSecondaryBlue900",
        "attributes": {
          "category": "color",
          "type": "secondary-blue",
          "item": "900"
        },
        "path": [
          "color",
          "secondary-blue",
          "900"
        ]
      }
    },
    "secondary-green": {
      "100": {
        "value": "#eaf3e2",
        "original": {
          "value": "{color.primary-01.100.value}"
        },
        "name": "ColorSecondaryGreen100",
        "attributes": {
          "category": "color",
          "type": "secondary-green",
          "item": "100"
        },
        "path": [
          "color",
          "secondary-green",
          "100"
        ]
      },
      "200": {
        "value": "#cbe3b5",
        "original": {
          "value": "{color.primary-01.200.value}"
        },
        "name": "ColorSecondaryGreen200",
        "attributes": {
          "category": "color",
          "type": "secondary-green",
          "item": "200"
        },
        "path": [
          "color",
          "secondary-green",
          "200"
        ]
      },
      "300": {
        "value": "#add585",
        "original": {
          "value": "{color.primary-01.300.value}"
        },
        "name": "ColorSecondaryGreen300",
        "attributes": {
          "category": "color",
          "type": "secondary-green",
          "item": "300"
        },
        "path": [
          "color",
          "secondary-green",
          "300"
        ]
      },
      "400": {
        "value": "#91c854",
        "original": {
          "value": "{color.primary-01.400.value}"
        },
        "name": "ColorSecondaryGreen400",
        "attributes": {
          "category": "color",
          "type": "secondary-green",
          "item": "400"
        },
        "path": [
          "color",
          "secondary-green",
          "400"
        ]
      },
      "500": {
        "value": "#78be20",
        "original": {
          "value": "{color.primary-01.500.value}"
        },
        "name": "ColorSecondaryGreen500",
        "attributes": {
          "category": "color",
          "type": "secondary-green",
          "item": "500"
        },
        "path": [
          "color",
          "secondary-green",
          "500"
        ]
      },
      "600": {
        "value": "#41a017",
        "original": {
          "value": "{color.primary-01.600.value}"
        },
        "name": "ColorSecondaryGreen600",
        "attributes": {
          "category": "color",
          "type": "secondary-green",
          "item": "600"
        },
        "path": [
          "color",
          "secondary-green",
          "600"
        ]
      },
      "700": {
        "value": "#158110",
        "original": {
          "value": "{color.primary-01.700.value}"
        },
        "name": "ColorSecondaryGreen700",
        "attributes": {
          "category": "color",
          "type": "secondary-green",
          "item": "700"
        },
        "path": [
          "color",
          "secondary-green",
          "700"
        ]
      },
      "800": {
        "value": "#0a601b",
        "original": {
          "value": "{color.primary-01.800.value}"
        },
        "name": "ColorSecondaryGreen800",
        "attributes": {
          "category": "color",
          "type": "secondary-green",
          "item": "800"
        },
        "path": [
          "color",
          "secondary-green",
          "800"
        ]
      },
      "900": {
        "value": "#053e1f",
        "original": {
          "value": "{color.primary-01.900.value}"
        },
        "name": "ColorSecondaryGreen900",
        "attributes": {
          "category": "color",
          "type": "secondary-green",
          "item": "900"
        },
        "path": [
          "color",
          "secondary-green",
          "900"
        ]
      }
    },
    "secondary-purple": {
      "100": {
        "value": "#efebfe",
        "original": {
          "value": "#EFEBFE"
        },
        "name": "ColorSecondaryPurple100",
        "attributes": {
          "category": "color",
          "type": "secondary-purple",
          "item": "100"
        },
        "path": [
          "color",
          "secondary-purple",
          "100"
        ]
      },
      "200": {
        "value": "#c7b0fa",
        "original": {
          "value": "#C7B0FA"
        },
        "name": "ColorSecondaryPurple200",
        "attributes": {
          "category": "color",
          "type": "secondary-purple",
          "item": "200"
        },
        "path": [
          "color",
          "secondary-purple",
          "200"
        ]
      },
      "300": {
        "value": "#a575f3",
        "original": {
          "value": "#A575F3"
        },
        "name": "ColorSecondaryPurple300",
        "attributes": {
          "category": "color",
          "type": "secondary-purple",
          "item": "300"
        },
        "path": [
          "color",
          "secondary-purple",
          "300"
        ]
      },
      "400": {
        "value": "#883be9",
        "original": {
          "value": "#883BE9"
        },
        "name": "ColorSecondaryPurple400",
        "attributes": {
          "category": "color",
          "type": "secondary-purple",
          "item": "400"
        },
        "path": [
          "color",
          "secondary-purple",
          "400"
        ]
      },
      "500": {
        "value": "#7000dd",
        "original": {
          "value": "#7000DD"
        },
        "name": "ColorSecondaryPurple500",
        "attributes": {
          "category": "color",
          "type": "secondary-purple",
          "item": "500"
        },
        "path": [
          "color",
          "secondary-purple",
          "500"
        ]
      },
      "600": {
        "value": "#5803b3",
        "original": {
          "value": "#5803B3"
        },
        "name": "ColorSecondaryPurple600",
        "attributes": {
          "category": "color",
          "type": "secondary-purple",
          "item": "600"
        },
        "path": [
          "color",
          "secondary-purple",
          "600"
        ]
      },
      "700": {
        "value": "#42058a",
        "original": {
          "value": "#42058A"
        },
        "name": "ColorSecondaryPurple700",
        "attributes": {
          "category": "color",
          "type": "secondary-purple",
          "item": "700"
        },
        "path": [
          "color",
          "secondary-purple",
          "700"
        ]
      },
      "800": {
        "value": "#2e0663",
        "original": {
          "value": "#2E0663"
        },
        "name": "ColorSecondaryPurple800",
        "attributes": {
          "category": "color",
          "type": "secondary-purple",
          "item": "800"
        },
        "path": [
          "color",
          "secondary-purple",
          "800"
        ]
      },
      "900": {
        "value": "#1c053d",
        "original": {
          "value": "#1C053D"
        },
        "name": "ColorSecondaryPurple900",
        "attributes": {
          "category": "color",
          "type": "secondary-purple",
          "item": "900"
        },
        "path": [
          "color",
          "secondary-purple",
          "900"
        ]
      }
    },
    "secondary-red": {
      "100": {
        "value": "#feedee",
        "original": {
          "value": "#FEEDEE"
        },
        "name": "ColorSecondaryRed100",
        "attributes": {
          "category": "color",
          "type": "secondary-red",
          "item": "100"
        },
        "path": [
          "color",
          "secondary-red",
          "100"
        ]
      },
      "200": {
        "value": "#fab9bc",
        "original": {
          "value": "#FAB9BC"
        },
        "name": "ColorSecondaryRed200",
        "attributes": {
          "category": "color",
          "type": "secondary-red",
          "item": "200"
        },
        "path": [
          "color",
          "secondary-red",
          "200"
        ]
      },
      "300": {
        "value": "#f38789",
        "original": {
          "value": "#F38789"
        },
        "name": "ColorSecondaryRed300",
        "attributes": {
          "category": "color",
          "type": "secondary-red",
          "item": "300"
        },
        "path": [
          "color",
          "secondary-red",
          "300"
        ]
      },
      "400": {
        "value": "#ea5d58",
        "original": {
          "value": "#EA5D58"
        },
        "name": "ColorSecondaryRed400",
        "attributes": {
          "category": "color",
          "type": "secondary-red",
          "item": "400"
        },
        "path": [
          "color",
          "secondary-red",
          "400"
        ]
      },
      "500": {
        "value": "#df382b",
        "original": {
          "value": "#DF382B"
        },
        "name": "ColorSecondaryRed500",
        "attributes": {
          "category": "color",
          "type": "secondary-red",
          "item": "500"
        },
        "path": [
          "color",
          "secondary-red",
          "500"
        ]
      },
      "600": {
        "value": "#b42a27",
        "original": {
          "value": "#B42A27"
        },
        "name": "ColorSecondaryRed600",
        "attributes": {
          "category": "color",
          "type": "secondary-red",
          "item": "600"
        },
        "path": [
          "color",
          "secondary-red",
          "600"
        ]
      },
      "700": {
        "value": "#8b2226",
        "original": {
          "value": "#8B2226"
        },
        "name": "ColorSecondaryRed700",
        "attributes": {
          "category": "color",
          "type": "secondary-red",
          "item": "700"
        },
        "path": [
          "color",
          "secondary-red",
          "700"
        ]
      },
      "800": {
        "value": "#641b21",
        "original": {
          "value": "#641B21"
        },
        "name": "ColorSecondaryRed800",
        "attributes": {
          "category": "color",
          "type": "secondary-red",
          "item": "800"
        },
        "path": [
          "color",
          "secondary-red",
          "800"
        ]
      },
      "900": {
        "value": "#3e1219",
        "original": {
          "value": "#3E1219"
        },
        "name": "ColorSecondaryRed900",
        "attributes": {
          "category": "color",
          "type": "secondary-red",
          "item": "900"
        },
        "path": [
          "color",
          "secondary-red",
          "900"
        ]
      }
    },
    "secondary-orange": {
      "100": {
        "value": "#fff5eb",
        "original": {
          "value": "#FFF5EB"
        },
        "name": "ColorSecondaryOrange100",
        "attributes": {
          "category": "color",
          "type": "secondary-orange",
          "item": "100"
        },
        "path": [
          "color",
          "secondary-orange",
          "100"
        ]
      },
      "200": {
        "value": "#ffdab2",
        "original": {
          "value": "#FFDAB2"
        },
        "name": "ColorSecondaryOrange200",
        "attributes": {
          "category": "color",
          "type": "secondary-orange",
          "item": "200"
        },
        "path": [
          "color",
          "secondary-orange",
          "200"
        ]
      },
      "300": {
        "value": "#ffc17d",
        "original": {
          "value": "#FFC17D"
        },
        "name": "ColorSecondaryOrange300",
        "attributes": {
          "category": "color",
          "type": "secondary-orange",
          "item": "300"
        },
        "path": [
          "color",
          "secondary-orange",
          "300"
        ]
      },
      "400": {
        "value": "#ffab4b",
        "original": {
          "value": "#FFAB4B"
        },
        "name": "ColorSecondaryOrange400",
        "attributes": {
          "category": "color",
          "type": "secondary-orange",
          "item": "400"
        },
        "path": [
          "color",
          "secondary-orange",
          "400"
        ]
      },
      "500": {
        "value": "#fc961e",
        "original": {
          "value": "#FC961E"
        },
        "name": "ColorSecondaryOrange500",
        "attributes": {
          "category": "color",
          "type": "secondary-orange",
          "item": "500"
        },
        "path": [
          "color",
          "secondary-orange",
          "500"
        ]
      },
      "600": {
        "value": "#c86f21",
        "original": {
          "value": "#C86F21"
        },
        "name": "ColorSecondaryOrange600",
        "attributes": {
          "category": "color",
          "type": "secondary-orange",
          "item": "600"
        },
        "path": [
          "color",
          "secondary-orange",
          "600"
        ]
      },
      "700": {
        "value": "#974f20",
        "original": {
          "value": "#974F20"
        },
        "name": "ColorSecondaryOrange700",
        "attributes": {
          "category": "color",
          "type": "secondary-orange",
          "item": "700"
        },
        "path": [
          "color",
          "secondary-orange",
          "700"
        ]
      },
      "800": {
        "value": "#6a351c",
        "original": {
          "value": "#6A351C"
        },
        "name": "ColorSecondaryOrange800",
        "attributes": {
          "category": "color",
          "type": "secondary-orange",
          "item": "800"
        },
        "path": [
          "color",
          "secondary-orange",
          "800"
        ]
      },
      "900": {
        "value": "#401f15",
        "original": {
          "value": "#401F15"
        },
        "name": "ColorSecondaryOrange900",
        "attributes": {
          "category": "color",
          "type": "secondary-orange",
          "item": "900"
        },
        "path": [
          "color",
          "secondary-orange",
          "900"
        ]
      }
    },
    "secondary-yellow": {
      "100": {
        "value": "#fff8e2",
        "original": {
          "value": "#FFF8E2"
        },
        "name": "ColorSecondaryYellow100",
        "attributes": {
          "category": "color",
          "type": "secondary-yellow",
          "item": "100"
        },
        "path": [
          "color",
          "secondary-yellow",
          "100"
        ]
      },
      "200": {
        "value": "#ffebaf",
        "original": {
          "value": "#FFEBAF"
        },
        "name": "ColorSecondaryYellow200",
        "attributes": {
          "category": "color",
          "type": "secondary-yellow",
          "item": "200"
        },
        "path": [
          "color",
          "secondary-yellow",
          "200"
        ]
      },
      "300": {
        "value": "#fee07d",
        "original": {
          "value": "#FEE07D"
        },
        "name": "ColorSecondaryYellow300",
        "attributes": {
          "category": "color",
          "type": "secondary-yellow",
          "item": "300"
        },
        "path": [
          "color",
          "secondary-yellow",
          "300"
        ]
      },
      "400": {
        "value": "#fcd64c",
        "original": {
          "value": "#FCD64C"
        },
        "name": "ColorSecondaryYellow400",
        "attributes": {
          "category": "color",
          "type": "secondary-yellow",
          "item": "400"
        },
        "path": [
          "color",
          "secondary-yellow",
          "400"
        ]
      },
      "500": {
        "value": "#f8cc1c",
        "original": {
          "value": "#F8CC1C"
        },
        "name": "ColorSecondaryYellow500",
        "attributes": {
          "category": "color",
          "type": "secondary-yellow",
          "item": "500"
        },
        "path": [
          "color",
          "secondary-yellow",
          "500"
        ]
      },
      "600": {
        "value": "#c9a21b",
        "original": {
          "value": "#C9A21B"
        },
        "name": "ColorSecondaryYellow600",
        "attributes": {
          "category": "color",
          "type": "secondary-yellow",
          "item": "600"
        },
        "path": [
          "color",
          "secondary-yellow",
          "600"
        ]
      },
      "700": {
        "value": "#9c7b18",
        "original": {
          "value": "#9C7B18"
        },
        "name": "ColorSecondaryYellow700",
        "attributes": {
          "category": "color",
          "type": "secondary-yellow",
          "item": "700"
        },
        "path": [
          "color",
          "secondary-yellow",
          "700"
        ]
      },
      "800": {
        "value": "#705613",
        "original": {
          "value": "#705613"
        },
        "name": "ColorSecondaryYellow800",
        "attributes": {
          "category": "color",
          "type": "secondary-yellow",
          "item": "800"
        },
        "path": [
          "color",
          "secondary-yellow",
          "800"
        ]
      },
      "900": {
        "value": "#46350d",
        "original": {
          "value": "#46350D"
        },
        "name": "ColorSecondaryYellow900",
        "attributes": {
          "category": "color",
          "type": "secondary-yellow",
          "item": "900"
        },
        "path": [
          "color",
          "secondary-yellow",
          "900"
        ]
      }
    },
    "danger": {
      "100": {
        "value": "#feedee",
        "original": {
          "value": "{color.secondary-red.100.value}"
        },
        "name": "ColorDanger100",
        "attributes": {
          "category": "color",
          "type": "danger",
          "item": "100"
        },
        "path": [
          "color",
          "danger",
          "100"
        ]
      },
      "200": {
        "value": "#fab9bc",
        "original": {
          "value": "{color.secondary-red.200.value}"
        },
        "name": "ColorDanger200",
        "attributes": {
          "category": "color",
          "type": "danger",
          "item": "200"
        },
        "path": [
          "color",
          "danger",
          "200"
        ]
      },
      "300": {
        "value": "#f38789",
        "original": {
          "value": "{color.secondary-red.300.value}"
        },
        "name": "ColorDanger300",
        "attributes": {
          "category": "color",
          "type": "danger",
          "item": "300"
        },
        "path": [
          "color",
          "danger",
          "300"
        ]
      },
      "400": {
        "value": "#ea5d58",
        "original": {
          "value": "{color.secondary-red.400.value}"
        },
        "name": "ColorDanger400",
        "attributes": {
          "category": "color",
          "type": "danger",
          "item": "400"
        },
        "path": [
          "color",
          "danger",
          "400"
        ]
      },
      "500": {
        "value": "#df382b",
        "original": {
          "value": "{color.secondary-red.500.value}"
        },
        "name": "ColorDanger500",
        "attributes": {
          "category": "color",
          "type": "danger",
          "item": "500"
        },
        "path": [
          "color",
          "danger",
          "500"
        ]
      },
      "600": {
        "value": "#b42a27",
        "original": {
          "value": "{color.secondary-red.600.value}"
        },
        "name": "ColorDanger600",
        "attributes": {
          "category": "color",
          "type": "danger",
          "item": "600"
        },
        "path": [
          "color",
          "danger",
          "600"
        ]
      },
      "700": {
        "value": "#8b2226",
        "original": {
          "value": "{color.secondary-red.700.value}"
        },
        "name": "ColorDanger700",
        "attributes": {
          "category": "color",
          "type": "danger",
          "item": "700"
        },
        "path": [
          "color",
          "danger",
          "700"
        ]
      },
      "800": {
        "value": "#641b21",
        "original": {
          "value": "{color.secondary-red.800.value}"
        },
        "name": "ColorDanger800",
        "attributes": {
          "category": "color",
          "type": "danger",
          "item": "800"
        },
        "path": [
          "color",
          "danger",
          "800"
        ]
      },
      "900": {
        "value": "#3e1219",
        "original": {
          "value": "{color.secondary-red.900.value}"
        },
        "name": "ColorDanger900",
        "attributes": {
          "category": "color",
          "type": "danger",
          "item": "900"
        },
        "path": [
          "color",
          "danger",
          "900"
        ]
      }
    },
    "info": {
      "100": {
        "value": "#ecfcfd",
        "original": {
          "value": "{color.secondary-blue.100.value}"
        },
        "name": "ColorInfo100",
        "attributes": {
          "category": "color",
          "type": "info",
          "item": "100"
        },
        "path": [
          "color",
          "info",
          "100"
        ]
      },
      "200": {
        "value": "#b7eef5",
        "original": {
          "value": "{color.secondary-blue.200.value}"
        },
        "name": "ColorInfo200",
        "attributes": {
          "category": "color",
          "type": "info",
          "item": "200"
        },
        "path": [
          "color",
          "info",
          "200"
        ]
      },
      "300": {
        "value": "#84dbeb",
        "original": {
          "value": "{color.secondary-blue.300.value}"
        },
        "name": "ColorInfo300",
        "attributes": {
          "category": "color",
          "type": "info",
          "item": "300"
        },
        "path": [
          "color",
          "info",
          "300"
        ]
      },
      "400": {
        "value": "#54c4de",
        "original": {
          "value": "{color.secondary-blue.400.value}"
        },
        "name": "ColorInfo400",
        "attributes": {
          "category": "color",
          "type": "info",
          "item": "400"
        },
        "path": [
          "color",
          "info",
          "400"
        ]
      },
      "500": {
        "value": "#25a8d0",
        "original": {
          "value": "{color.secondary-blue.500.value}"
        },
        "name": "ColorInfo500",
        "attributes": {
          "category": "color",
          "type": "info",
          "item": "500"
        },
        "path": [
          "color",
          "info",
          "500"
        ]
      },
      "600": {
        "value": "#2282a8",
        "original": {
          "value": "{color.secondary-blue.600.value}"
        },
        "name": "ColorInfo600",
        "attributes": {
          "category": "color",
          "type": "info",
          "item": "600"
        },
        "path": [
          "color",
          "info",
          "600"
        ]
      },
      "700": {
        "value": "#1e5f82",
        "original": {
          "value": "{color.secondary-blue.700.value}"
        },
        "name": "ColorInfo700",
        "attributes": {
          "category": "color",
          "type": "info",
          "item": "700"
        },
        "path": [
          "color",
          "info",
          "700"
        ]
      },
      "800": {
        "value": "#18415d",
        "original": {
          "value": "{color.secondary-blue.800.value}"
        },
        "name": "ColorInfo800",
        "attributes": {
          "category": "color",
          "type": "info",
          "item": "800"
        },
        "path": [
          "color",
          "info",
          "800"
        ]
      },
      "900": {
        "value": "#102739",
        "original": {
          "value": "{color.secondary-blue.900.value}"
        },
        "name": "ColorInfo900",
        "attributes": {
          "category": "color",
          "type": "info",
          "item": "900"
        },
        "path": [
          "color",
          "info",
          "900"
        ]
      }
    },
    "warning": {
      "100": {
        "value": "#fff5eb",
        "original": {
          "value": "{color.secondary-orange.100.value}"
        },
        "name": "ColorWarning100",
        "attributes": {
          "category": "color",
          "type": "warning",
          "item": "100"
        },
        "path": [
          "color",
          "warning",
          "100"
        ]
      },
      "200": {
        "value": "#ffdab2",
        "original": {
          "value": "{color.secondary-orange.200.value}"
        },
        "name": "ColorWarning200",
        "attributes": {
          "category": "color",
          "type": "warning",
          "item": "200"
        },
        "path": [
          "color",
          "warning",
          "200"
        ]
      },
      "300": {
        "value": "#ffc17d",
        "original": {
          "value": "{color.secondary-orange.300.value}"
        },
        "name": "ColorWarning300",
        "attributes": {
          "category": "color",
          "type": "warning",
          "item": "300"
        },
        "path": [
          "color",
          "warning",
          "300"
        ]
      },
      "400": {
        "value": "#ffab4b",
        "original": {
          "value": "{color.secondary-orange.400.value}"
        },
        "name": "ColorWarning400",
        "attributes": {
          "category": "color",
          "type": "warning",
          "item": "400"
        },
        "path": [
          "color",
          "warning",
          "400"
        ]
      },
      "500": {
        "value": "#fc961e",
        "original": {
          "value": "{color.secondary-orange.500.value}"
        },
        "name": "ColorWarning500",
        "attributes": {
          "category": "color",
          "type": "warning",
          "item": "500"
        },
        "path": [
          "color",
          "warning",
          "500"
        ]
      },
      "600": {
        "value": "#c86f21",
        "original": {
          "value": "{color.secondary-orange.600.value}"
        },
        "name": "ColorWarning600",
        "attributes": {
          "category": "color",
          "type": "warning",
          "item": "600"
        },
        "path": [
          "color",
          "warning",
          "600"
        ]
      },
      "700": {
        "value": "#974f20",
        "original": {
          "value": "{color.secondary-orange.700.value}"
        },
        "name": "ColorWarning700",
        "attributes": {
          "category": "color",
          "type": "warning",
          "item": "700"
        },
        "path": [
          "color",
          "warning",
          "700"
        ]
      },
      "800": {
        "value": "#6a351c",
        "original": {
          "value": "{color.secondary-orange.800.value}"
        },
        "name": "ColorWarning800",
        "attributes": {
          "category": "color",
          "type": "warning",
          "item": "800"
        },
        "path": [
          "color",
          "warning",
          "800"
        ]
      },
      "900": {
        "value": "#401f15",
        "original": {
          "value": "{color.secondary-orange.900.value}"
        },
        "name": "ColorWarning900",
        "attributes": {
          "category": "color",
          "type": "warning",
          "item": "900"
        },
        "path": [
          "color",
          "warning",
          "900"
        ]
      }
    },
    "success": {
      "100": {
        "value": "#eaf3e2",
        "original": {
          "value": "{color.secondary-green.100.value}"
        },
        "name": "ColorSuccess100",
        "attributes": {
          "category": "color",
          "type": "success",
          "item": "100"
        },
        "path": [
          "color",
          "success",
          "100"
        ]
      },
      "200": {
        "value": "#cbe3b5",
        "original": {
          "value": "{color.secondary-green.200.value}"
        },
        "name": "ColorSuccess200",
        "attributes": {
          "category": "color",
          "type": "success",
          "item": "200"
        },
        "path": [
          "color",
          "success",
          "200"
        ]
      },
      "300": {
        "value": "#add585",
        "original": {
          "value": "{color.secondary-green.300.value}"
        },
        "name": "ColorSuccess300",
        "attributes": {
          "category": "color",
          "type": "success",
          "item": "300"
        },
        "path": [
          "color",
          "success",
          "300"
        ]
      },
      "400": {
        "value": "#91c854",
        "original": {
          "value": "{color.secondary-green.400.value}"
        },
        "name": "ColorSuccess400",
        "attributes": {
          "category": "color",
          "type": "success",
          "item": "400"
        },
        "path": [
          "color",
          "success",
          "400"
        ]
      },
      "500": {
        "value": "#78be20",
        "original": {
          "value": "{color.secondary-green.500.value}"
        },
        "name": "ColorSuccess500",
        "attributes": {
          "category": "color",
          "type": "success",
          "item": "500"
        },
        "path": [
          "color",
          "success",
          "500"
        ]
      },
      "600": {
        "value": "#41a017",
        "original": {
          "value": "{color.secondary-green.600.value}"
        },
        "name": "ColorSuccess600",
        "attributes": {
          "category": "color",
          "type": "success",
          "item": "600"
        },
        "path": [
          "color",
          "success",
          "600"
        ]
      },
      "700": {
        "value": "#158110",
        "original": {
          "value": "{color.secondary-green.700.value}"
        },
        "name": "ColorSuccess700",
        "attributes": {
          "category": "color",
          "type": "success",
          "item": "700"
        },
        "path": [
          "color",
          "success",
          "700"
        ]
      },
      "800": {
        "value": "#0a601b",
        "original": {
          "value": "{color.secondary-green.800.value}"
        },
        "name": "ColorSuccess800",
        "attributes": {
          "category": "color",
          "type": "success",
          "item": "800"
        },
        "path": [
          "color",
          "success",
          "800"
        ]
      },
      "900": {
        "value": "#053e1f",
        "original": {
          "value": "{color.secondary-green.900.value}"
        },
        "name": "ColorSuccess900",
        "attributes": {
          "category": "color",
          "type": "success",
          "item": "900"
        },
        "path": [
          "color",
          "success",
          "900"
        ]
      }
    },
    "button": {
      "solid": {
        "background": {
          "value": "#78be20",
          "original": {
            "value": "{color.primary-01.500.value}"
          },
          "name": "ColorButtonSolidBackground",
          "attributes": {
            "category": "color",
            "type": "button",
            "item": "solid",
            "subitem": "background"
          },
          "path": [
            "color",
            "button",
            "solid",
            "background"
          ]
        },
        "font": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorButtonSolidFont",
          "attributes": {
            "category": "color",
            "type": "button",
            "item": "solid",
            "subitem": "font"
          },
          "path": [
            "color",
            "button",
            "solid",
            "font"
          ]
        },
        "focus": {
          "border": {
            "value": "#158110",
            "original": {
              "value": "{color.primary-01.700.value}"
            },
            "name": "ColorButtonSolidFocusBorder",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid",
              "subitem": "focus",
              "state": "border"
            },
            "path": [
              "color",
              "button",
              "solid",
              "focus",
              "border"
            ]
          }
        },
        "disabled": {
          "background": {
            "value": "#d3d2d6",
            "original": {
              "value": "{color.grey.200.value}"
            },
            "name": "ColorButtonSolidDisabledBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid",
              "subitem": "disabled",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "solid",
              "disabled",
              "background"
            ]
          },
          "font": {
            "value": "#6f676c",
            "original": {
              "value": "{color.grey.600.value}"
            },
            "name": "ColorButtonSolidDisabledFont",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid",
              "subitem": "disabled",
              "state": "font"
            },
            "path": [
              "color",
              "button",
              "solid",
              "disabled",
              "font"
            ]
          }
        },
        "active": {
          "background": {
            "value": "#158110",
            "original": {
              "value": "{color.primary-01.700.value}"
            },
            "name": "ColorButtonSolidActiveBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid",
              "subitem": "active",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "solid",
              "active",
              "background"
            ]
          }
        },
        "hover": {
          "background": {
            "value": "#41a017",
            "original": {
              "value": "{color.primary-01.600.value}"
            },
            "name": "ColorButtonSolidHoverBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid",
              "subitem": "hover",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "solid",
              "hover",
              "background"
            ]
          },
          "font": {
            "value": "#ffffff",
            "original": {
              "value": "{color.grey.000.value}"
            },
            "name": "ColorButtonSolidHoverFont",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid",
              "subitem": "hover",
              "state": "font"
            },
            "path": [
              "color",
              "button",
              "solid",
              "hover",
              "font"
            ]
          }
        }
      },
      "solid-primary-02": {
        "background": {
          "value": "#007574",
          "original": {
            "value": "{color.primary-02.500.value}"
          },
          "name": "ColorButtonSolidPrimary02Background",
          "attributes": {
            "category": "color",
            "type": "button",
            "item": "solid-primary-02",
            "subitem": "background"
          },
          "path": [
            "color",
            "button",
            "solid-primary-02",
            "background"
          ]
        },
        "font": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorButtonSolidPrimary02Font",
          "attributes": {
            "category": "color",
            "type": "button",
            "item": "solid-primary-02",
            "subitem": "font"
          },
          "path": [
            "color",
            "button",
            "solid-primary-02",
            "font"
          ]
        },
        "focus": {
          "border": {
            "value": "#062b35",
            "original": {
              "value": "{color.primary-02.900.value}"
            },
            "name": "ColorButtonSolidPrimary02FocusBorder",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid-primary-02",
              "subitem": "focus",
              "state": "border"
            },
            "path": [
              "color",
              "button",
              "solid-primary-02",
              "focus",
              "border"
            ]
          }
        },
        "disabled": {
          "background": {
            "value": "#d3d2d6",
            "original": {
              "value": "{color.grey.200.value}"
            },
            "name": "ColorButtonSolidPrimary02DisabledBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid-primary-02",
              "subitem": "disabled",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "solid-primary-02",
              "disabled",
              "background"
            ]
          },
          "font": {
            "value": "#6f676c",
            "original": {
              "value": "{color.grey.600.value}"
            },
            "name": "ColorButtonSolidPrimary02DisabledFont",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid-primary-02",
              "subitem": "disabled",
              "state": "font"
            },
            "path": [
              "color",
              "button",
              "solid-primary-02",
              "disabled",
              "font"
            ]
          }
        },
        "active": {
          "background": {
            "value": "#062b35",
            "original": {
              "value": "{color.primary-02.900.value}"
            },
            "name": "ColorButtonSolidPrimary02ActiveBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid-primary-02",
              "subitem": "active",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "solid-primary-02",
              "active",
              "background"
            ]
          }
        },
        "hover": {
          "background": {
            "value": "#063a44",
            "original": {
              "value": "{color.primary-02.800.value}"
            },
            "name": "ColorButtonSolidPrimary02HoverBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid-primary-02",
              "subitem": "hover",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "solid-primary-02",
              "hover",
              "background"
            ]
          },
          "font": {
            "value": "#ffffff",
            "original": {
              "value": "{color.grey.000.value}"
            },
            "name": "ColorButtonSolidPrimary02HoverFont",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid-primary-02",
              "subitem": "hover",
              "state": "font"
            },
            "path": [
              "color",
              "button",
              "solid-primary-02",
              "hover",
              "font"
            ]
          }
        }
      },
      "solid-neutral": {
        "background": {
          "value": "#887f87",
          "original": {
            "value": "{color.grey.500.value}"
          },
          "name": "ColorButtonSolidNeutralBackground",
          "attributes": {
            "category": "color",
            "type": "button",
            "item": "solid-neutral",
            "subitem": "background"
          },
          "path": [
            "color",
            "button",
            "solid-neutral",
            "background"
          ]
        },
        "font": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorButtonSolidNeutralFont",
          "attributes": {
            "category": "color",
            "type": "button",
            "item": "solid-neutral",
            "subitem": "font"
          },
          "path": [
            "color",
            "button",
            "solid-neutral",
            "font"
          ]
        },
        "focus": {
          "border": {
            "value": "#222020",
            "original": {
              "value": "{color.grey.900.value}"
            },
            "name": "ColorButtonSolidNeutralFocusBorder",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid-neutral",
              "subitem": "focus",
              "state": "border"
            },
            "path": [
              "color",
              "button",
              "solid-neutral",
              "focus",
              "border"
            ]
          }
        },
        "disabled": {
          "background": {
            "value": "#d3d2d6",
            "original": {
              "value": "{color.grey.200.value}"
            },
            "name": "ColorButtonSolidNeutralDisabledBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid-neutral",
              "subitem": "disabled",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "solid-neutral",
              "disabled",
              "background"
            ]
          },
          "font": {
            "value": "#6f676c",
            "original": {
              "value": "{color.grey.600.value}"
            },
            "name": "ColorButtonSolidNeutralDisabledFont",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid-neutral",
              "subitem": "disabled",
              "state": "font"
            },
            "path": [
              "color",
              "button",
              "solid-neutral",
              "disabled",
              "font"
            ]
          }
        },
        "active": {
          "background": {
            "value": "#3c3738",
            "original": {
              "value": "{color.grey.800.value}"
            },
            "name": "ColorButtonSolidNeutralActiveBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid-neutral",
              "subitem": "active",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "solid-neutral",
              "active",
              "background"
            ]
          }
        },
        "hover": {
          "background": {
            "value": "#554f52",
            "original": {
              "value": "{color.grey.700.value}"
            },
            "name": "ColorButtonSolidNeutralHoverBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid-neutral",
              "subitem": "hover",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "solid-neutral",
              "hover",
              "background"
            ]
          },
          "font": {
            "value": "#ffffff",
            "original": {
              "value": "{color.grey.000.value}"
            },
            "name": "ColorButtonSolidNeutralHoverFont",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid-neutral",
              "subitem": "hover",
              "state": "font"
            },
            "path": [
              "color",
              "button",
              "solid-neutral",
              "hover",
              "font"
            ]
          }
        }
      },
      "solid-danger": {
        "background": {
          "value": "#df382b",
          "original": {
            "value": "{color.danger.500.value}"
          },
          "name": "ColorButtonSolidDangerBackground",
          "attributes": {
            "category": "color",
            "type": "button",
            "item": "solid-danger",
            "subitem": "background"
          },
          "path": [
            "color",
            "button",
            "solid-danger",
            "background"
          ]
        },
        "font": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorButtonSolidDangerFont",
          "attributes": {
            "category": "color",
            "type": "button",
            "item": "solid-danger",
            "subitem": "font"
          },
          "path": [
            "color",
            "button",
            "solid-danger",
            "font"
          ]
        },
        "focus": {
          "border": {
            "value": "#8b2226",
            "original": {
              "value": "{color.danger.700.value}"
            },
            "name": "ColorButtonSolidDangerFocusBorder",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid-danger",
              "subitem": "focus",
              "state": "border"
            },
            "path": [
              "color",
              "button",
              "solid-danger",
              "focus",
              "border"
            ]
          }
        },
        "disabled": {
          "background": {
            "value": "#d3d2d6",
            "original": {
              "value": "{color.grey.200.value}"
            },
            "name": "ColorButtonSolidDangerDisabledBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid-danger",
              "subitem": "disabled",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "solid-danger",
              "disabled",
              "background"
            ]
          },
          "font": {
            "value": "#6f676c",
            "original": {
              "value": "{color.grey.600.value}"
            },
            "name": "ColorButtonSolidDangerDisabledFont",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid-danger",
              "subitem": "disabled",
              "state": "font"
            },
            "path": [
              "color",
              "button",
              "solid-danger",
              "disabled",
              "font"
            ]
          }
        },
        "active": {
          "background": {
            "value": "#8b2226",
            "original": {
              "value": "{color.danger.700.value}"
            },
            "name": "ColorButtonSolidDangerActiveBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid-danger",
              "subitem": "active",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "solid-danger",
              "active",
              "background"
            ]
          }
        },
        "hover": {
          "background": {
            "value": "#b42a27",
            "original": {
              "value": "{color.danger.600.value}"
            },
            "name": "ColorButtonSolidDangerHoverBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid-danger",
              "subitem": "hover",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "solid-danger",
              "hover",
              "background"
            ]
          },
          "font": {
            "value": "#ffffff",
            "original": {
              "value": "{color.grey.000.value}"
            },
            "name": "ColorButtonSolidDangerHoverFont",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "solid-danger",
              "subitem": "hover",
              "state": "font"
            },
            "path": [
              "color",
              "button",
              "solid-danger",
              "hover",
              "font"
            ]
          }
        }
      },
      "bordered": {
        "background": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorButtonBorderedBackground",
          "attributes": {
            "category": "color",
            "type": "button",
            "item": "bordered",
            "subitem": "background"
          },
          "path": [
            "color",
            "button",
            "bordered",
            "background"
          ]
        },
        "border": {
          "value": "#78be20",
          "original": {
            "value": "{color.primary-01.500.value}"
          },
          "name": "ColorButtonBorderedBorder",
          "attributes": {
            "category": "color",
            "type": "button",
            "item": "bordered",
            "subitem": "border"
          },
          "path": [
            "color",
            "button",
            "bordered",
            "border"
          ]
        },
        "font": {
          "value": "#78be20",
          "original": {
            "value": "{color.primary-01.500.value}"
          },
          "name": "ColorButtonBorderedFont",
          "attributes": {
            "category": "color",
            "type": "button",
            "item": "bordered",
            "subitem": "font"
          },
          "path": [
            "color",
            "button",
            "bordered",
            "font"
          ]
        },
        "focus": {
          "border": {
            "value": "#158110",
            "original": {
              "value": "{color.primary-01.700.value}"
            },
            "name": "ColorButtonBorderedFocusBorder",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "bordered",
              "subitem": "focus",
              "state": "border"
            },
            "path": [
              "color",
              "button",
              "bordered",
              "focus",
              "border"
            ]
          }
        },
        "disabled": {
          "background": {
            "value": "#d3d2d6",
            "original": {
              "value": "{color.grey.200.value}"
            },
            "name": "ColorButtonBorderedDisabledBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "bordered",
              "subitem": "disabled",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "bordered",
              "disabled",
              "background"
            ]
          },
          "font": {
            "value": "#6f676c",
            "original": {
              "value": "{color.grey.600.value}"
            },
            "name": "ColorButtonBorderedDisabledFont",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "bordered",
              "subitem": "disabled",
              "state": "font"
            },
            "path": [
              "color",
              "button",
              "bordered",
              "disabled",
              "font"
            ]
          }
        },
        "active": {
          "background": {
            "value": "#cbe3b5",
            "original": {
              "value": "{color.primary-01.200.value}"
            },
            "name": "ColorButtonBorderedActiveBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "bordered",
              "subitem": "active",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "bordered",
              "active",
              "background"
            ]
          }
        },
        "hover": {
          "background": {
            "value": "#eaf3e2",
            "original": {
              "value": "{color.primary-01.100.value}"
            },
            "name": "ColorButtonBorderedHoverBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "bordered",
              "subitem": "hover",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "bordered",
              "hover",
              "background"
            ]
          }
        }
      },
      "bordered-primary-02": {
        "background": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorButtonBorderedPrimary02Background",
          "attributes": {
            "category": "color",
            "type": "button",
            "item": "bordered-primary-02",
            "subitem": "background"
          },
          "path": [
            "color",
            "button",
            "bordered-primary-02",
            "background"
          ]
        },
        "border": {
          "value": "#007574",
          "original": {
            "value": "{color.primary-02.500.value}"
          },
          "name": "ColorButtonBorderedPrimary02Border",
          "attributes": {
            "category": "color",
            "type": "button",
            "item": "bordered-primary-02",
            "subitem": "border"
          },
          "path": [
            "color",
            "button",
            "bordered-primary-02",
            "border"
          ]
        },
        "font": {
          "value": "#007574",
          "original": {
            "value": "{color.primary-02.500.value}"
          },
          "name": "ColorButtonBorderedPrimary02Font",
          "attributes": {
            "category": "color",
            "type": "button",
            "item": "bordered-primary-02",
            "subitem": "font"
          },
          "path": [
            "color",
            "button",
            "bordered-primary-02",
            "font"
          ]
        },
        "focus": {
          "border": {
            "value": "#062b35",
            "original": {
              "value": "{color.primary-02.900.value}"
            },
            "name": "ColorButtonBorderedPrimary02FocusBorder",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "bordered-primary-02",
              "subitem": "focus",
              "state": "border"
            },
            "path": [
              "color",
              "button",
              "bordered-primary-02",
              "focus",
              "border"
            ]
          }
        },
        "disabled": {
          "background": {
            "value": "#d3d2d6",
            "original": {
              "value": "{color.grey.200.value}"
            },
            "name": "ColorButtonBorderedPrimary02DisabledBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "bordered-primary-02",
              "subitem": "disabled",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "bordered-primary-02",
              "disabled",
              "background"
            ]
          },
          "font": {
            "value": "#6f676c",
            "original": {
              "value": "{color.grey.600.value}"
            },
            "name": "ColorButtonBorderedPrimary02DisabledFont",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "bordered-primary-02",
              "subitem": "disabled",
              "state": "font"
            },
            "path": [
              "color",
              "button",
              "bordered-primary-02",
              "disabled",
              "font"
            ]
          }
        },
        "active": {
          "background": {
            "value": "#a5d1cb",
            "original": {
              "value": "{color.primary-02.200.value}"
            },
            "name": "ColorButtonBorderedPrimary02ActiveBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "bordered-primary-02",
              "subitem": "active",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "bordered-primary-02",
              "active",
              "background"
            ]
          }
        },
        "hover": {
          "background": {
            "value": "#dbedea",
            "original": {
              "value": "{color.primary-02.100.value}"
            },
            "name": "ColorButtonBorderedPrimary02HoverBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "bordered-primary-02",
              "subitem": "hover",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "bordered-primary-02",
              "hover",
              "background"
            ]
          }
        }
      },
      "bordered-neutral": {
        "background": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorButtonBorderedNeutralBackground",
          "attributes": {
            "category": "color",
            "type": "button",
            "item": "bordered-neutral",
            "subitem": "background"
          },
          "path": [
            "color",
            "button",
            "bordered-neutral",
            "background"
          ]
        },
        "border": {
          "value": "#887f87",
          "original": {
            "value": "{color.grey.500.value}"
          },
          "name": "ColorButtonBorderedNeutralBorder",
          "attributes": {
            "category": "color",
            "type": "button",
            "item": "bordered-neutral",
            "subitem": "border"
          },
          "path": [
            "color",
            "button",
            "bordered-neutral",
            "border"
          ]
        },
        "font": {
          "value": "#887f87",
          "original": {
            "value": "{color.grey.500.value}"
          },
          "name": "ColorButtonBorderedNeutralFont",
          "attributes": {
            "category": "color",
            "type": "button",
            "item": "bordered-neutral",
            "subitem": "font"
          },
          "path": [
            "color",
            "button",
            "bordered-neutral",
            "font"
          ]
        },
        "focus": {
          "border": {
            "value": "#222020",
            "original": {
              "value": "{color.grey.900.value}"
            },
            "name": "ColorButtonBorderedNeutralFocusBorder",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "bordered-neutral",
              "subitem": "focus",
              "state": "border"
            },
            "path": [
              "color",
              "button",
              "bordered-neutral",
              "focus",
              "border"
            ]
          }
        },
        "disabled": {
          "background": {
            "value": "#d3d2d6",
            "original": {
              "value": "{color.grey.200.value}"
            },
            "name": "ColorButtonBorderedNeutralDisabledBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "bordered-neutral",
              "subitem": "disabled",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "bordered-neutral",
              "disabled",
              "background"
            ]
          },
          "font": {
            "value": "#6f676c",
            "original": {
              "value": "{color.grey.600.value}"
            },
            "name": "ColorButtonBorderedNeutralDisabledFont",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "bordered-neutral",
              "subitem": "disabled",
              "state": "font"
            },
            "path": [
              "color",
              "button",
              "bordered-neutral",
              "disabled",
              "font"
            ]
          }
        },
        "active": {
          "background": {
            "value": "#d3d2d6",
            "original": {
              "value": "{color.grey.200.value}"
            },
            "name": "ColorButtonBorderedNeutralActiveBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "bordered-neutral",
              "subitem": "active",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "bordered-neutral",
              "active",
              "background"
            ]
          }
        },
        "hover": {
          "background": {
            "value": "#eeeef0",
            "original": {
              "value": "{color.grey.100.value}"
            },
            "name": "ColorButtonBorderedNeutralHoverBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "bordered-neutral",
              "subitem": "hover",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "bordered-neutral",
              "hover",
              "background"
            ]
          }
        }
      },
      "bordered-danger": {
        "background": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorButtonBorderedDangerBackground",
          "attributes": {
            "category": "color",
            "type": "button",
            "item": "bordered-danger",
            "subitem": "background"
          },
          "path": [
            "color",
            "button",
            "bordered-danger",
            "background"
          ]
        },
        "border": {
          "value": "#df382b",
          "original": {
            "value": "{color.secondary-red.500.value}"
          },
          "name": "ColorButtonBorderedDangerBorder",
          "attributes": {
            "category": "color",
            "type": "button",
            "item": "bordered-danger",
            "subitem": "border"
          },
          "path": [
            "color",
            "button",
            "bordered-danger",
            "border"
          ]
        },
        "font": {
          "value": "#df382b",
          "original": {
            "value": "{color.secondary-red.500.value}"
          },
          "name": "ColorButtonBorderedDangerFont",
          "attributes": {
            "category": "color",
            "type": "button",
            "item": "bordered-danger",
            "subitem": "font"
          },
          "path": [
            "color",
            "button",
            "bordered-danger",
            "font"
          ]
        },
        "focus": {
          "border": {
            "value": "#8b2226",
            "original": {
              "value": "{color.secondary-red.700.value}"
            },
            "name": "ColorButtonBorderedDangerFocusBorder",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "bordered-danger",
              "subitem": "focus",
              "state": "border"
            },
            "path": [
              "color",
              "button",
              "bordered-danger",
              "focus",
              "border"
            ]
          }
        },
        "disabled": {
          "background": {
            "value": "#d3d2d6",
            "original": {
              "value": "{color.grey.200.value}"
            },
            "name": "ColorButtonBorderedDangerDisabledBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "bordered-danger",
              "subitem": "disabled",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "bordered-danger",
              "disabled",
              "background"
            ]
          },
          "font": {
            "value": "#6f676c",
            "original": {
              "value": "{color.grey.600.value}"
            },
            "name": "ColorButtonBorderedDangerDisabledFont",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "bordered-danger",
              "subitem": "disabled",
              "state": "font"
            },
            "path": [
              "color",
              "button",
              "bordered-danger",
              "disabled",
              "font"
            ]
          }
        },
        "active": {
          "background": {
            "value": "#fab9bc",
            "original": {
              "value": "{color.secondary-red.200.value}"
            },
            "name": "ColorButtonBorderedDangerActiveBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "bordered-danger",
              "subitem": "active",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "bordered-danger",
              "active",
              "background"
            ]
          }
        },
        "hover": {
          "background": {
            "value": "#feedee",
            "original": {
              "value": "{color.secondary-red.100.value}"
            },
            "name": "ColorButtonBorderedDangerHoverBackground",
            "attributes": {
              "category": "color",
              "type": "button",
              "item": "bordered-danger",
              "subitem": "hover",
              "state": "background"
            },
            "path": [
              "color",
              "button",
              "bordered-danger",
              "hover",
              "background"
            ]
          }
        }
      }
    },
    "divider": {
      "lightest": {
        "value": "#ffffff",
        "original": {
          "value": "{color.grey.000.value}"
        },
        "name": "ColorDividerLightest",
        "attributes": {
          "category": "color",
          "type": "divider",
          "item": "lightest"
        },
        "path": [
          "color",
          "divider",
          "lightest"
        ]
      },
      "light": {
        "value": "#bab6bc",
        "original": {
          "value": "{color.grey.300.value}"
        },
        "name": "ColorDividerLight",
        "attributes": {
          "category": "color",
          "type": "divider",
          "item": "light"
        },
        "path": [
          "color",
          "divider",
          "light"
        ]
      },
      "default": {
        "value": "#6f676c",
        "original": {
          "value": "{color.grey.600.value}"
        },
        "name": "ColorDividerDefault",
        "attributes": {
          "category": "color",
          "type": "divider",
          "item": "default"
        },
        "path": [
          "color",
          "divider",
          "default"
        ]
      },
      "dark": {
        "value": "#000000",
        "original": {
          "value": "{color.grey.999.value}"
        },
        "name": "ColorDividerDark",
        "attributes": {
          "category": "color",
          "type": "divider",
          "item": "dark"
        },
        "path": [
          "color",
          "divider",
          "dark"
        ]
      }
    },
    "fields": {
      "error": {
        "value": "#b42a27",
        "original": {
          "value": "{color.font.danger.value}"
        },
        "name": "ColorFieldsError",
        "attributes": {
          "category": "color",
          "type": "fields",
          "item": "error"
        },
        "path": [
          "color",
          "fields",
          "error"
        ]
      },
      "label": {
        "value": "#3c3738",
        "original": {
          "value": "{color.font.dark.value}"
        },
        "name": "ColorFieldsLabel",
        "attributes": {
          "category": "color",
          "type": "fields",
          "item": "label"
        },
        "path": [
          "color",
          "fields",
          "label"
        ]
      },
      "requirement": {
        "value": "#6f676c",
        "original": {
          "value": "{color.font.light.value}"
        },
        "name": "ColorFieldsRequirement",
        "attributes": {
          "category": "color",
          "type": "fields",
          "item": "requirement"
        },
        "path": [
          "color",
          "fields",
          "requirement"
        ]
      },
      "help": {
        "value": "#6f676c",
        "original": {
          "value": "{color.font.light.value}"
        },
        "name": "ColorFieldsHelp",
        "attributes": {
          "category": "color",
          "type": "fields",
          "item": "help"
        },
        "path": [
          "color",
          "fields",
          "help"
        ]
      }
    },
    "fileuploader": {
      "font": {
        "value": "#000000",
        "original": {
          "value": "{color.grey.999.value}"
        },
        "name": "ColorFileuploaderFont",
        "attributes": {
          "category": "color",
          "type": "fileuploader",
          "item": "font"
        },
        "path": [
          "color",
          "fileuploader",
          "font"
        ]
      },
      "files": {
        "list": {
          "value": "#eeeef0",
          "original": {
            "value": "{color.grey.100.value}"
          },
          "name": "ColorFileuploaderFilesList",
          "attributes": {
            "category": "color",
            "type": "fileuploader",
            "item": "files",
            "subitem": "list"
          },
          "path": [
            "color",
            "fileuploader",
            "files",
            "list"
          ]
        },
        "delete": {
          "value": "#d3d2d6",
          "original": {
            "value": "{color.grey.200.value}"
          },
          "name": "ColorFileuploaderFilesDelete",
          "attributes": {
            "category": "color",
            "type": "fileuploader",
            "item": "files",
            "subitem": "delete"
          },
          "path": [
            "color",
            "fileuploader",
            "files",
            "delete"
          ]
        }
      },
      "valid": {
        "value": "#78be20",
        "original": {
          "value": "{color.success.500.value}"
        },
        "name": "ColorFileuploaderValid",
        "attributes": {
          "category": "color",
          "type": "fileuploader",
          "item": "valid"
        },
        "path": [
          "color",
          "fileuploader",
          "valid"
        ]
      },
      "alert": {
        "value": "#b42a27",
        "original": {
          "value": "{color.danger.600.value}"
        },
        "name": "ColorFileuploaderAlert",
        "attributes": {
          "category": "color",
          "type": "fileuploader",
          "item": "alert"
        },
        "path": [
          "color",
          "fileuploader",
          "alert"
        ]
      }
    },
    "flag": {
      "solid": {
        "background": {
          "value": "#78be20",
          "original": {
            "value": "{color.primary-01.500.value}"
          },
          "name": "ColorFlagSolidBackground",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "solid",
            "subitem": "background"
          },
          "path": [
            "color",
            "flag",
            "solid",
            "background"
          ]
        },
        "border": {
          "value": "#78be20",
          "original": {
            "value": "{color.primary-01.500.value}"
          },
          "name": "ColorFlagSolidBorder",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "solid",
            "subitem": "border"
          },
          "path": [
            "color",
            "flag",
            "solid",
            "border"
          ]
        },
        "text": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorFlagSolidText",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "solid",
            "subitem": "text"
          },
          "path": [
            "color",
            "flag",
            "solid",
            "text"
          ]
        }
      },
      "solid-primary-02": {
        "background": {
          "value": "#035f64",
          "original": {
            "value": "{color.primary-02.600.value}"
          },
          "name": "ColorFlagSolidPrimary02Background",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "solid-primary-02",
            "subitem": "background"
          },
          "path": [
            "color",
            "flag",
            "solid-primary-02",
            "background"
          ]
        },
        "border": {
          "value": "#035f64",
          "original": {
            "value": "{color.primary-02.600.value}"
          },
          "name": "ColorFlagSolidPrimary02Border",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "solid-primary-02",
            "subitem": "border"
          },
          "path": [
            "color",
            "flag",
            "solid-primary-02",
            "border"
          ]
        },
        "text": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorFlagSolidPrimary02Text",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "solid-primary-02",
            "subitem": "text"
          },
          "path": [
            "color",
            "flag",
            "solid-primary-02",
            "text"
          ]
        }
      },
      "solid-dark": {
        "background": {
          "value": "#000000",
          "original": {
            "value": "{color.grey.999.value}"
          },
          "name": "ColorFlagSolidDarkBackground",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "solid-dark",
            "subitem": "background"
          },
          "path": [
            "color",
            "flag",
            "solid-dark",
            "background"
          ]
        },
        "border": {
          "value": "#000000",
          "original": {
            "value": "{color.grey.999.value}"
          },
          "name": "ColorFlagSolidDarkBorder",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "solid-dark",
            "subitem": "border"
          },
          "path": [
            "color",
            "flag",
            "solid-dark",
            "border"
          ]
        },
        "text": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorFlagSolidDarkText",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "solid-dark",
            "subitem": "text"
          },
          "path": [
            "color",
            "flag",
            "solid-dark",
            "text"
          ]
        }
      },
      "solid-light": {
        "background": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorFlagSolidLightBackground",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "solid-light",
            "subitem": "background"
          },
          "path": [
            "color",
            "flag",
            "solid-light",
            "background"
          ]
        },
        "border": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorFlagSolidLightBorder",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "solid-light",
            "subitem": "border"
          },
          "path": [
            "color",
            "flag",
            "solid-light",
            "border"
          ]
        },
        "text": {
          "value": "#000000",
          "original": {
            "value": "{color.grey.999.value}"
          },
          "name": "ColorFlagSolidLightText",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "solid-light",
            "subitem": "text"
          },
          "path": [
            "color",
            "flag",
            "solid-light",
            "text"
          ]
        }
      },
      "solid-danger": {
        "background": {
          "value": "#df382b",
          "original": {
            "value": "{color.secondary-red.500.value}"
          },
          "name": "ColorFlagSolidDangerBackground",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "solid-danger",
            "subitem": "background"
          },
          "path": [
            "color",
            "flag",
            "solid-danger",
            "background"
          ]
        },
        "border": {
          "value": "#df382b",
          "original": {
            "value": "{color.secondary-red.500.value}"
          },
          "name": "ColorFlagSolidDangerBorder",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "solid-danger",
            "subitem": "border"
          },
          "path": [
            "color",
            "flag",
            "solid-danger",
            "border"
          ]
        },
        "text": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorFlagSolidDangerText",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "solid-danger",
            "subitem": "text"
          },
          "path": [
            "color",
            "flag",
            "solid-danger",
            "text"
          ]
        }
      },
      "bordered": {
        "background": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorFlagBorderedBackground",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "bordered",
            "subitem": "background"
          },
          "path": [
            "color",
            "flag",
            "bordered",
            "background"
          ]
        },
        "border": {
          "value": "#78be20",
          "original": {
            "value": "{color.primary-01.500.value}"
          },
          "name": "ColorFlagBorderedBorder",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "bordered",
            "subitem": "border"
          },
          "path": [
            "color",
            "flag",
            "bordered",
            "border"
          ]
        },
        "text": {
          "value": "#78be20",
          "original": {
            "value": "{color.primary-01.500.value}"
          },
          "name": "ColorFlagBorderedText",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "bordered",
            "subitem": "text"
          },
          "path": [
            "color",
            "flag",
            "bordered",
            "text"
          ]
        }
      },
      "bordered-primary-02": {
        "background": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorFlagBorderedPrimary02Background",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "bordered-primary-02",
            "subitem": "background"
          },
          "path": [
            "color",
            "flag",
            "bordered-primary-02",
            "background"
          ]
        },
        "border": {
          "value": "#035f64",
          "original": {
            "value": "{color.primary-02.600.value}"
          },
          "name": "ColorFlagBorderedPrimary02Border",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "bordered-primary-02",
            "subitem": "border"
          },
          "path": [
            "color",
            "flag",
            "bordered-primary-02",
            "border"
          ]
        },
        "text": {
          "value": "#035f64",
          "original": {
            "value": "{color.primary-02.600.value}"
          },
          "name": "ColorFlagBorderedPrimary02Text",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "bordered-primary-02",
            "subitem": "text"
          },
          "path": [
            "color",
            "flag",
            "bordered-primary-02",
            "text"
          ]
        }
      },
      "bordered-dark": {
        "background": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorFlagBorderedDarkBackground",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "bordered-dark",
            "subitem": "background"
          },
          "path": [
            "color",
            "flag",
            "bordered-dark",
            "background"
          ]
        },
        "border": {
          "value": "#000000",
          "original": {
            "value": "{color.grey.999.value}"
          },
          "name": "ColorFlagBorderedDarkBorder",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "bordered-dark",
            "subitem": "border"
          },
          "path": [
            "color",
            "flag",
            "bordered-dark",
            "border"
          ]
        },
        "text": {
          "value": "#000000",
          "original": {
            "value": "{color.grey.999.value}"
          },
          "name": "ColorFlagBorderedDarkText",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "bordered-dark",
            "subitem": "text"
          },
          "path": [
            "color",
            "flag",
            "bordered-dark",
            "text"
          ]
        }
      },
      "bordered-light": {
        "background": {
          "value": "#000000",
          "original": {
            "value": "{color.grey.999.value}"
          },
          "name": "ColorFlagBorderedLightBackground",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "bordered-light",
            "subitem": "background"
          },
          "path": [
            "color",
            "flag",
            "bordered-light",
            "background"
          ]
        },
        "border": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorFlagBorderedLightBorder",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "bordered-light",
            "subitem": "border"
          },
          "path": [
            "color",
            "flag",
            "bordered-light",
            "border"
          ]
        },
        "text": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorFlagBorderedLightText",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "bordered-light",
            "subitem": "text"
          },
          "path": [
            "color",
            "flag",
            "bordered-light",
            "text"
          ]
        }
      },
      "bordered-danger": {
        "background": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorFlagBorderedDangerBackground",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "bordered-danger",
            "subitem": "background"
          },
          "path": [
            "color",
            "flag",
            "bordered-danger",
            "background"
          ]
        },
        "border": {
          "value": "#df382b",
          "original": {
            "value": "{color.secondary-red.500.value}"
          },
          "name": "ColorFlagBorderedDangerBorder",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "bordered-danger",
            "subitem": "border"
          },
          "path": [
            "color",
            "flag",
            "bordered-danger",
            "border"
          ]
        },
        "text": {
          "value": "#df382b",
          "original": {
            "value": "{color.secondary-red.500.value}"
          },
          "name": "ColorFlagBorderedDangerText",
          "attributes": {
            "category": "color",
            "type": "flag",
            "item": "bordered-danger",
            "subitem": "text"
          },
          "path": [
            "color",
            "flag",
            "bordered-danger",
            "text"
          ]
        }
      }
    },
    "focus": {
      "gap": {
        "value": "#ffffff",
        "original": {
          "value": "{color.grey.000.value}"
        },
        "name": "ColorFocusGap",
        "attributes": {
          "category": "color",
          "type": "focus",
          "item": "gap"
        },
        "path": [
          "color",
          "focus",
          "gap"
        ]
      },
      "border": {
        "value": "#25a8d0",
        "original": {
          "value": "{color.secondary-blue.500.value}"
        },
        "name": "ColorFocusBorder",
        "attributes": {
          "category": "color",
          "type": "focus",
          "item": "border"
        },
        "path": [
          "color",
          "focus",
          "border"
        ]
      }
    },
    "font": {
      "primary-01": {
        "value": "#78be20",
        "original": {
          "value": "{color.primary-01.500.value}"
        },
        "name": "ColorFontPrimary01",
        "attributes": {
          "category": "color",
          "type": "font",
          "item": "primary-01"
        },
        "path": [
          "color",
          "font",
          "primary-01"
        ]
      },
      "primary-02": {
        "value": "#007574",
        "original": {
          "value": "{color.primary-02.500.value}"
        },
        "name": "ColorFontPrimary02",
        "attributes": {
          "category": "color",
          "type": "font",
          "item": "primary-02"
        },
        "path": [
          "color",
          "font",
          "primary-02"
        ]
      },
      "darkest": {
        "value": "#000000",
        "original": {
          "value": "{color.grey.999.value}"
        },
        "name": "ColorFontDarkest",
        "attributes": {
          "category": "color",
          "type": "font",
          "item": "darkest"
        },
        "path": [
          "color",
          "font",
          "darkest"
        ]
      },
      "darker": {
        "value": "#222020",
        "original": {
          "value": "{color.grey.900.value}"
        },
        "name": "ColorFontDarker",
        "attributes": {
          "category": "color",
          "type": "font",
          "item": "darker"
        },
        "path": [
          "color",
          "font",
          "darker"
        ]
      },
      "dark": {
        "value": "#3c3738",
        "original": {
          "value": "{color.grey.800.value}"
        },
        "name": "ColorFontDark",
        "attributes": {
          "category": "color",
          "type": "font",
          "item": "dark"
        },
        "path": [
          "color",
          "font",
          "dark"
        ]
      },
      "light": {
        "value": "#6f676c",
        "original": {
          "value": "{color.grey.600.value}"
        },
        "name": "ColorFontLight",
        "attributes": {
          "category": "color",
          "type": "font",
          "item": "light"
        },
        "path": [
          "color",
          "font",
          "light"
        ]
      },
      "lightest": {
        "value": "#ffffff",
        "original": {
          "value": "{color.grey.000.value}"
        },
        "name": "ColorFontLightest",
        "attributes": {
          "category": "color",
          "type": "font",
          "item": "lightest"
        },
        "path": [
          "color",
          "font",
          "lightest"
        ]
      },
      "info": {
        "value": "#2282a8",
        "original": {
          "value": "{color.info.600.value}"
        },
        "name": "ColorFontInfo",
        "attributes": {
          "category": "color",
          "type": "font",
          "item": "info"
        },
        "path": [
          "color",
          "font",
          "info"
        ]
      },
      "success": {
        "value": "#41a017",
        "original": {
          "value": "{color.success.600.value}"
        },
        "name": "ColorFontSuccess",
        "attributes": {
          "category": "color",
          "type": "font",
          "item": "success"
        },
        "path": [
          "color",
          "font",
          "success"
        ]
      },
      "warning": {
        "value": "#c86f21",
        "original": {
          "value": "{color.warning.600.value}"
        },
        "name": "ColorFontWarning",
        "attributes": {
          "category": "color",
          "type": "font",
          "item": "warning"
        },
        "path": [
          "color",
          "font",
          "warning"
        ]
      },
      "danger": {
        "value": "#b42a27",
        "original": {
          "value": "{color.danger.600.value}"
        },
        "name": "ColorFontDanger",
        "attributes": {
          "category": "color",
          "type": "font",
          "item": "danger"
        },
        "path": [
          "color",
          "font",
          "danger"
        ]
      }
    },
    "input": {
      "text": {
        "value": "#222020",
        "original": {
          "value": "{color.grey.900.value}"
        },
        "name": "ColorInputText",
        "attributes": {
          "category": "color",
          "type": "input",
          "item": "text"
        },
        "path": [
          "color",
          "input",
          "text"
        ]
      },
      "border": {
        "value": "#6f676c",
        "original": {
          "value": "{color.grey.600.value}"
        },
        "name": "ColorInputBorder",
        "attributes": {
          "category": "color",
          "type": "input",
          "item": "border"
        },
        "path": [
          "color",
          "input",
          "border"
        ]
      },
      "placeholder": {
        "value": "#887f87",
        "original": {
          "value": "{color.grey.500.value}"
        },
        "name": "ColorInputPlaceholder",
        "attributes": {
          "category": "color",
          "type": "input",
          "item": "placeholder"
        },
        "path": [
          "color",
          "input",
          "placeholder"
        ]
      },
      "background": {
        "value": "#ffffff",
        "original": {
          "value": "{color.grey.000.value}"
        },
        "name": "ColorInputBackground",
        "attributes": {
          "category": "color",
          "type": "input",
          "item": "background"
        },
        "path": [
          "color",
          "input",
          "background"
        ]
      },
      "disabled": {
        "border": {
          "value": "#eeeef0",
          "original": {
            "value": "{color.grey.100.value}"
          },
          "name": "ColorInputDisabledBorder",
          "attributes": {
            "category": "color",
            "type": "input",
            "item": "disabled",
            "subitem": "border"
          },
          "path": [
            "color",
            "input",
            "disabled",
            "border"
          ]
        },
        "background": {
          "value": "#eeeef0",
          "original": {
            "value": "{color.grey.100.value}"
          },
          "name": "ColorInputDisabledBackground",
          "attributes": {
            "category": "color",
            "type": "input",
            "item": "disabled",
            "subitem": "background"
          },
          "path": [
            "color",
            "input",
            "disabled",
            "background"
          ]
        },
        "icon": {
          "value": "#a19ba2",
          "original": {
            "value": "{color.grey.400.value}"
          },
          "name": "ColorInputDisabledIcon",
          "attributes": {
            "category": "color",
            "type": "input",
            "item": "disabled",
            "subitem": "icon"
          },
          "path": [
            "color",
            "input",
            "disabled",
            "icon"
          ]
        }
      },
      "hover": {
        "border": {
          "value": "#222020",
          "original": {
            "value": "{color.grey.900.value}"
          },
          "name": "ColorInputHoverBorder",
          "attributes": {
            "category": "color",
            "type": "input",
            "item": "hover",
            "subitem": "border"
          },
          "path": [
            "color",
            "input",
            "hover",
            "border"
          ]
        }
      },
      "focus": {
        "border": {
          "value": "#25a8d0",
          "original": {
            "value": "{color.secondary-blue.500.value}"
          },
          "name": "ColorInputFocusBorder",
          "attributes": {
            "category": "color",
            "type": "input",
            "item": "focus",
            "subitem": "border"
          },
          "path": [
            "color",
            "input",
            "focus",
            "border"
          ]
        }
      },
      "valid": {
        "border": {
          "value": "#78be20",
          "original": {
            "value": "{color.success.500.value}"
          },
          "name": "ColorInputValidBorder",
          "attributes": {
            "category": "color",
            "type": "input",
            "item": "valid",
            "subitem": "border"
          },
          "path": [
            "color",
            "input",
            "valid",
            "border"
          ]
        },
        "hover": {
          "border": {
            "value": "#0a601b",
            "original": {
              "value": "{color.success.800.value}"
            },
            "name": "ColorInputValidHoverBorder",
            "attributes": {
              "category": "color",
              "type": "input",
              "item": "valid",
              "subitem": "hover",
              "state": "border"
            },
            "path": [
              "color",
              "input",
              "valid",
              "hover",
              "border"
            ]
          }
        }
      },
      "invalid": {
        "border": {
          "value": "#b42a27",
          "original": {
            "value": "{color.danger.600.value}"
          },
          "name": "ColorInputInvalidBorder",
          "attributes": {
            "category": "color",
            "type": "input",
            "item": "invalid",
            "subitem": "border"
          },
          "path": [
            "color",
            "input",
            "invalid",
            "border"
          ]
        },
        "hover": {
          "border": {
            "value": "#641b21",
            "original": {
              "value": "{color.danger.800.value}"
            },
            "name": "ColorInputInvalidHoverBorder",
            "attributes": {
              "category": "color",
              "type": "input",
              "item": "invalid",
              "subitem": "hover",
              "state": "border"
            },
            "path": [
              "color",
              "input",
              "invalid",
              "hover",
              "border"
            ]
          }
        }
      },
      "checked": {
        "border": {
          "value": "#78be20",
          "original": {
            "value": "{color.primary-01.500.value}"
          },
          "name": "ColorInputCheckedBorder",
          "attributes": {
            "category": "color",
            "type": "input",
            "item": "checked",
            "subitem": "border"
          },
          "path": [
            "color",
            "input",
            "checked",
            "border"
          ]
        },
        "background": {
          "value": "#78be20",
          "original": {
            "value": "{color.primary-01.500.value}"
          },
          "name": "ColorInputCheckedBackground",
          "attributes": {
            "category": "color",
            "type": "input",
            "item": "checked",
            "subitem": "background"
          },
          "path": [
            "color",
            "input",
            "checked",
            "background"
          ]
        },
        "icon": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorInputCheckedIcon",
          "attributes": {
            "category": "color",
            "type": "input",
            "item": "checked",
            "subitem": "icon"
          },
          "path": [
            "color",
            "input",
            "checked",
            "icon"
          ]
        },
        "hover": {
          "border": {
            "value": "#0a601b",
            "original": {
              "value": "{color.primary-01.800.value}"
            },
            "name": "ColorInputCheckedHoverBorder",
            "attributes": {
              "category": "color",
              "type": "input",
              "item": "checked",
              "subitem": "hover",
              "state": "border"
            },
            "path": [
              "color",
              "input",
              "checked",
              "hover",
              "border"
            ]
          }
        }
      }
    },
    "link": {
      "dark": {
        "base": {
          "value": "#000000",
          "original": {
            "value": "{color.grey.999.value}"
          },
          "name": "ColorLinkDarkBase",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "dark",
            "subitem": "base"
          },
          "path": [
            "color",
            "link",
            "dark",
            "base"
          ]
        },
        "visited": {
          "value": "#3c3738",
          "original": {
            "value": "{color.grey.800.value}"
          },
          "name": "ColorLinkDarkVisited",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "dark",
            "subitem": "visited"
          },
          "path": [
            "color",
            "link",
            "dark",
            "visited"
          ]
        },
        "active": {
          "value": "#3c3738",
          "original": {
            "value": "{color.grey.800.value}"
          },
          "name": "ColorLinkDarkActive",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "dark",
            "subitem": "active"
          },
          "path": [
            "color",
            "link",
            "dark",
            "active"
          ]
        },
        "disabled": {
          "value": "#eeeef0",
          "original": {
            "value": "{color.grey.100.value}"
          },
          "name": "ColorLinkDarkDisabled",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "dark",
            "subitem": "disabled"
          },
          "path": [
            "color",
            "link",
            "dark",
            "disabled"
          ]
        },
        "hover": {
          "value": "#6f676c",
          "original": {
            "value": "{color.grey.600.value}"
          },
          "name": "ColorLinkDarkHover",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "dark",
            "subitem": "hover"
          },
          "path": [
            "color",
            "link",
            "dark",
            "hover"
          ]
        }
      },
      "light": {
        "base": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorLinkLightBase",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "light",
            "subitem": "base"
          },
          "path": [
            "color",
            "link",
            "light",
            "base"
          ]
        },
        "visited": {
          "value": "#d3d2d6",
          "original": {
            "value": "{color.grey.200.value}"
          },
          "name": "ColorLinkLightVisited",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "light",
            "subitem": "visited"
          },
          "path": [
            "color",
            "link",
            "light",
            "visited"
          ]
        },
        "active": {
          "value": "#d3d2d6",
          "original": {
            "value": "{color.grey.200.value}"
          },
          "name": "ColorLinkLightActive",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "light",
            "subitem": "active"
          },
          "path": [
            "color",
            "link",
            "light",
            "active"
          ]
        },
        "disabled": {
          "value": "#eeeef0",
          "original": {
            "value": "{color.grey.100.value}"
          },
          "name": "ColorLinkLightDisabled",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "light",
            "subitem": "disabled"
          },
          "path": [
            "color",
            "link",
            "light",
            "disabled"
          ]
        },
        "hover": {
          "value": "#a19ba2",
          "original": {
            "value": "{color.grey.400.value}"
          },
          "name": "ColorLinkLightHover",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "light",
            "subitem": "hover"
          },
          "path": [
            "color",
            "link",
            "light",
            "hover"
          ]
        }
      },
      "primary": {
        "base": {
          "value": "#78be20",
          "original": {
            "value": "{color.primary-01.500.value}"
          },
          "name": "ColorLinkPrimaryBase",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "primary",
            "subitem": "base"
          },
          "path": [
            "color",
            "link",
            "primary",
            "base"
          ]
        },
        "visited": {
          "value": "#158110",
          "original": {
            "value": "{color.primary-01.700.value}"
          },
          "name": "ColorLinkPrimaryVisited",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "primary",
            "subitem": "visited"
          },
          "path": [
            "color",
            "link",
            "primary",
            "visited"
          ]
        },
        "active": {
          "value": "#158110",
          "original": {
            "value": "{color.primary-01.700.value}"
          },
          "name": "ColorLinkPrimaryActive",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "primary",
            "subitem": "active"
          },
          "path": [
            "color",
            "link",
            "primary",
            "active"
          ]
        },
        "disabled": {
          "value": "#eeeef0",
          "original": {
            "value": "{color.grey.100.value}"
          },
          "name": "ColorLinkPrimaryDisabled",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "primary",
            "subitem": "disabled"
          },
          "path": [
            "color",
            "link",
            "primary",
            "disabled"
          ]
        },
        "hover": {
          "value": "#053e1f",
          "original": {
            "value": "{color.primary-01.900.value}"
          },
          "name": "ColorLinkPrimaryHover",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "primary",
            "subitem": "hover"
          },
          "path": [
            "color",
            "link",
            "primary",
            "hover"
          ]
        }
      },
      "primary-02": {
        "base": {
          "value": "#035f64",
          "original": {
            "value": "{color.primary-02.600.value}"
          },
          "name": "ColorLinkPrimary02Base",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "primary-02",
            "subitem": "base"
          },
          "path": [
            "color",
            "link",
            "primary-02",
            "base"
          ]
        },
        "visited": {
          "value": "#044c53",
          "original": {
            "value": "{color.primary-02.700.value}"
          },
          "name": "ColorLinkPrimary02Visited",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "primary-02",
            "subitem": "visited"
          },
          "path": [
            "color",
            "link",
            "primary-02",
            "visited"
          ]
        },
        "active": {
          "value": "#044c53",
          "original": {
            "value": "{color.primary-02.700.value}"
          },
          "name": "ColorLinkPrimary02Active",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "primary-02",
            "subitem": "active"
          },
          "path": [
            "color",
            "link",
            "primary-02",
            "active"
          ]
        },
        "disabled": {
          "value": "#eeeef0",
          "original": {
            "value": "{color.grey.100.value}"
          },
          "name": "ColorLinkPrimary02Disabled",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "primary-02",
            "subitem": "disabled"
          },
          "path": [
            "color",
            "link",
            "primary-02",
            "disabled"
          ]
        },
        "hover": {
          "value": "#062b35",
          "original": {
            "value": "{color.primary-02.900.value}"
          },
          "name": "ColorLinkPrimary02Hover",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "primary-02",
            "subitem": "hover"
          },
          "path": [
            "color",
            "link",
            "primary-02",
            "hover"
          ]
        }
      },
      "danger": {
        "base": {
          "value": "#b42a27",
          "original": {
            "value": "{color.secondary-red.600.value}"
          },
          "name": "ColorLinkDangerBase",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "danger",
            "subitem": "base"
          },
          "path": [
            "color",
            "link",
            "danger",
            "base"
          ]
        },
        "visited": {
          "value": "#8b2226",
          "original": {
            "value": "{color.secondary-red.700.value}"
          },
          "name": "ColorLinkDangerVisited",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "danger",
            "subitem": "visited"
          },
          "path": [
            "color",
            "link",
            "danger",
            "visited"
          ]
        },
        "active": {
          "value": "#8b2226",
          "original": {
            "value": "{color.secondary-red.700.value}"
          },
          "name": "ColorLinkDangerActive",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "danger",
            "subitem": "active"
          },
          "path": [
            "color",
            "link",
            "danger",
            "active"
          ]
        },
        "disabled": {
          "value": "#eeeef0",
          "original": {
            "value": "{color.grey.100.value}"
          },
          "name": "ColorLinkDangerDisabled",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "danger",
            "subitem": "disabled"
          },
          "path": [
            "color",
            "link",
            "danger",
            "disabled"
          ]
        },
        "hover": {
          "value": "#3e1219",
          "original": {
            "value": "{color.secondary-red.900.value}"
          },
          "name": "ColorLinkDangerHover",
          "attributes": {
            "category": "color",
            "type": "link",
            "item": "danger",
            "subitem": "hover"
          },
          "path": [
            "color",
            "link",
            "danger",
            "hover"
          ]
        }
      }
    },
    "notification": {
      "font": {
        "value": "#000000",
        "original": {
          "value": "{color.grey.999.value}"
        },
        "name": "ColorNotificationFont",
        "attributes": {
          "category": "color",
          "type": "notification",
          "item": "font"
        },
        "path": [
          "color",
          "notification",
          "font"
        ]
      },
      "information": {
        "background": {
          "value": "#ecfcfd",
          "original": {
            "value": "{color.secondary-blue.100.value}"
          },
          "name": "ColorNotificationInformationBackground",
          "attributes": {
            "category": "color",
            "type": "notification",
            "item": "information",
            "subitem": "background"
          },
          "path": [
            "color",
            "notification",
            "information",
            "background"
          ]
        },
        "border": {
          "value": "#25a8d0",
          "original": {
            "value": "{color.secondary-blue.500.value}"
          },
          "name": "ColorNotificationInformationBorder",
          "attributes": {
            "category": "color",
            "type": "notification",
            "item": "information",
            "subitem": "border"
          },
          "path": [
            "color",
            "notification",
            "information",
            "border"
          ]
        }
      },
      "success": {
        "background": {
          "value": "#eaf3e2",
          "original": {
            "value": "{color.primary-01.100.value}"
          },
          "name": "ColorNotificationSuccessBackground",
          "attributes": {
            "category": "color",
            "type": "notification",
            "item": "success",
            "subitem": "background"
          },
          "path": [
            "color",
            "notification",
            "success",
            "background"
          ]
        },
        "border": {
          "value": "#78be20",
          "original": {
            "value": "{color.primary-01.500.value}"
          },
          "name": "ColorNotificationSuccessBorder",
          "attributes": {
            "category": "color",
            "type": "notification",
            "item": "success",
            "subitem": "border"
          },
          "path": [
            "color",
            "notification",
            "success",
            "border"
          ]
        }
      },
      "warning": {
        "background": {
          "value": "#fff5eb",
          "original": {
            "value": "{color.secondary-orange.100.value}"
          },
          "name": "ColorNotificationWarningBackground",
          "attributes": {
            "category": "color",
            "type": "notification",
            "item": "warning",
            "subitem": "background"
          },
          "path": [
            "color",
            "notification",
            "warning",
            "background"
          ]
        },
        "border": {
          "value": "#fc961e",
          "original": {
            "value": "{color.secondary-orange.500.value}"
          },
          "name": "ColorNotificationWarningBorder",
          "attributes": {
            "category": "color",
            "type": "notification",
            "item": "warning",
            "subitem": "border"
          },
          "path": [
            "color",
            "notification",
            "warning",
            "border"
          ]
        }
      },
      "danger": {
        "background": {
          "value": "#feedee",
          "original": {
            "value": "{color.secondary-red.100.value}"
          },
          "name": "ColorNotificationDangerBackground",
          "attributes": {
            "category": "color",
            "type": "notification",
            "item": "danger",
            "subitem": "background"
          },
          "path": [
            "color",
            "notification",
            "danger",
            "background"
          ]
        },
        "border": {
          "value": "#df382b",
          "original": {
            "value": "{color.secondary-red.500.value}"
          },
          "name": "ColorNotificationDangerBorder",
          "attributes": {
            "category": "color",
            "type": "notification",
            "item": "danger",
            "subitem": "border"
          },
          "path": [
            "color",
            "notification",
            "danger",
            "border"
          ]
        }
      }
    },
    "progress": {
      "background": {
        "value": "#d3d2d6",
        "original": {
          "value": "{color.grey.200.value}"
        },
        "name": "ColorProgressBackground",
        "attributes": {
          "category": "color",
          "type": "progress",
          "item": "background"
        },
        "path": [
          "color",
          "progress",
          "background"
        ]
      },
      "indicator": {
        "value": "#2282a8",
        "original": {
          "value": "{color.info.600.value}"
        },
        "name": "ColorProgressIndicator",
        "attributes": {
          "category": "color",
          "type": "progress",
          "item": "indicator"
        },
        "path": [
          "color",
          "progress",
          "indicator"
        ]
      },
      "percentage": {
        "default": {
          "value": "#222020",
          "original": {
            "value": "{color.grey.900.value}"
          },
          "name": "ColorProgressPercentageDefault",
          "attributes": {
            "category": "color",
            "type": "progress",
            "item": "percentage",
            "subitem": "default"
          },
          "path": [
            "color",
            "progress",
            "percentage",
            "default"
          ]
        },
        "half": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorProgressPercentageHalf",
          "attributes": {
            "category": "color",
            "type": "progress",
            "item": "percentage",
            "subitem": "half"
          },
          "path": [
            "color",
            "progress",
            "percentage",
            "half"
          ]
        }
      },
      "branded": {
        "indicator": {
          "value": "#78be20",
          "original": {
            "value": "{color.primary-01.500.value}"
          },
          "name": "ColorProgressBrandedIndicator",
          "attributes": {
            "category": "color",
            "type": "progress",
            "item": "branded",
            "subitem": "indicator"
          },
          "path": [
            "color",
            "progress",
            "branded",
            "indicator"
          ]
        }
      }
    },
    "star": {
      "empty": {
        "value": "#d3d2d6",
        "original": {
          "value": "{color.grey.200.value}"
        },
        "name": "ColorStarEmpty",
        "attributes": {
          "category": "color",
          "type": "star",
          "item": "empty"
        },
        "path": [
          "color",
          "star",
          "empty"
        ]
      },
      "focus": {
        "value": "#25a8d0",
        "original": {
          "value": "{color.secondary-blue.500.value}"
        },
        "name": "ColorStarFocus",
        "attributes": {
          "category": "color",
          "type": "star",
          "item": "focus"
        },
        "path": [
          "color",
          "star",
          "focus"
        ]
      },
      "full": {
        "value": "#fc961e",
        "original": {
          "value": "{color.secondary-orange.500.value}"
        },
        "name": "ColorStarFull",
        "attributes": {
          "category": "color",
          "type": "star",
          "item": "full"
        },
        "path": [
          "color",
          "star",
          "full"
        ]
      },
      "hover": {
        "value": "#ffc17d",
        "original": {
          "value": "{color.secondary-orange.300.value}"
        },
        "name": "ColorStarHover",
        "attributes": {
          "category": "color",
          "type": "star",
          "item": "hover"
        },
        "path": [
          "color",
          "star",
          "hover"
        ]
      }
    },
    "tabs": {
      "background": {
        "value": "#ffffff",
        "original": {
          "value": "{color.grey.000.value}"
        },
        "name": "ColorTabsBackground",
        "attributes": {
          "category": "color",
          "type": "tabs",
          "item": "background"
        },
        "path": [
          "color",
          "tabs",
          "background"
        ]
      },
      "shadow": {
        "value": "#000000",
        "original": {
          "value": "{color.grey.999.value}"
        },
        "name": "ColorTabsShadow",
        "attributes": {
          "category": "color",
          "type": "tabs",
          "item": "shadow"
        },
        "path": [
          "color",
          "tabs",
          "shadow"
        ]
      },
      "default": {
        "value": "#222020",
        "original": {
          "value": "{color.font.darker.value}"
        },
        "name": "ColorTabsDefault",
        "attributes": {
          "category": "color",
          "type": "tabs",
          "item": "default"
        },
        "path": [
          "color",
          "tabs",
          "default"
        ]
      },
      "hover": {
        "value": "#41a017",
        "original": {
          "value": "{color.font.success.value}"
        },
        "name": "ColorTabsHover",
        "attributes": {
          "category": "color",
          "type": "tabs",
          "item": "hover"
        },
        "path": [
          "color",
          "tabs",
          "hover"
        ]
      },
      "disabled": {
        "value": "#6f676c",
        "original": {
          "value": "{color.font.light.value}"
        },
        "name": "ColorTabsDisabled",
        "attributes": {
          "category": "color",
          "type": "tabs",
          "item": "disabled"
        },
        "path": [
          "color",
          "tabs",
          "disabled"
        ]
      },
      "active": {
        "value": "#78be20",
        "original": {
          "value": "{color.font.primary-01.value}"
        },
        "name": "ColorTabsActive",
        "attributes": {
          "category": "color",
          "type": "tabs",
          "item": "active"
        },
        "path": [
          "color",
          "tabs",
          "active"
        ]
      },
      "active-disabled": {
        "value": "#cbe3b5",
        "original": {
          "value": "{color.primary-01.200.value}"
        },
        "name": "ColorTabsActiveDisabled",
        "attributes": {
          "category": "color",
          "type": "tabs",
          "item": "active-disabled"
        },
        "path": [
          "color",
          "tabs",
          "active-disabled"
        ]
      }
    },
    "tag": {
      "text": {
        "light": {
          "background": {
            "value": "#ffffff",
            "original": {
              "value": "{color.grey.000.value}"
            },
            "name": "ColorTagTextLightBackground",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "text",
              "subitem": "light",
              "state": "background"
            },
            "path": [
              "color",
              "tag",
              "text",
              "light",
              "background"
            ]
          },
          "border": {
            "value": "#554f52",
            "original": {
              "value": "{color.grey.700.value}"
            },
            "name": "ColorTagTextLightBorder",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "text",
              "subitem": "light",
              "state": "border"
            },
            "path": [
              "color",
              "tag",
              "text",
              "light",
              "border"
            ]
          },
          "text": {
            "value": "#554f52",
            "original": {
              "value": "{color.grey.700.value}"
            },
            "name": "ColorTagTextLightText",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "text",
              "subitem": "light",
              "state": "text"
            },
            "path": [
              "color",
              "tag",
              "text",
              "light",
              "text"
            ]
          }
        },
        "dark": {
          "background": {
            "value": "#000000",
            "original": {
              "value": "{color.grey.999.value}"
            },
            "name": "ColorTagTextDarkBackground",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "text",
              "subitem": "dark",
              "state": "background"
            },
            "path": [
              "color",
              "tag",
              "text",
              "dark",
              "background"
            ]
          },
          "border": {
            "value": "#ffffff",
            "original": {
              "value": "{color.grey.000.value}"
            },
            "name": "ColorTagTextDarkBorder",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "text",
              "subitem": "dark",
              "state": "border"
            },
            "path": [
              "color",
              "tag",
              "text",
              "dark",
              "border"
            ]
          },
          "text": {
            "value": "#ffffff",
            "original": {
              "value": "{color.grey.000.value}"
            },
            "name": "ColorTagTextDarkText",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "text",
              "subitem": "dark",
              "state": "text"
            },
            "path": [
              "color",
              "tag",
              "text",
              "dark",
              "text"
            ]
          }
        }
      },
      "link": {
        "light": {
          "background": {
            "value": "#ffffff",
            "original": {
              "value": "{color.grey.000.value}"
            },
            "name": "ColorTagLinkLightBackground",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "link",
              "subitem": "light",
              "state": "background"
            },
            "path": [
              "color",
              "tag",
              "link",
              "light",
              "background"
            ]
          },
          "border": {
            "value": "#554f52",
            "original": {
              "value": "{color.grey.700.value}"
            },
            "name": "ColorTagLinkLightBorder",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "link",
              "subitem": "light",
              "state": "border"
            },
            "path": [
              "color",
              "tag",
              "link",
              "light",
              "border"
            ]
          },
          "text": {
            "value": "#554f52",
            "original": {
              "value": "{color.grey.700.value}"
            },
            "name": "ColorTagLinkLightText",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "link",
              "subitem": "light",
              "state": "text"
            },
            "path": [
              "color",
              "tag",
              "link",
              "light",
              "text"
            ]
          },
          "hover": {
            "background": {
              "value": "#eeeef0",
              "original": {
                "value": "{color.grey.100.value}"
              },
              "name": "ColorTagLinkLightHoverBackground",
              "attributes": {
                "category": "color",
                "type": "tag",
                "item": "link",
                "subitem": "light",
                "state": "hover"
              },
              "path": [
                "color",
                "tag",
                "link",
                "light",
                "hover",
                "background"
              ]
            }
          },
          "active": {
            "background": {
              "value": "#d3d2d6",
              "original": {
                "value": "{color.grey.200.value}"
              },
              "name": "ColorTagLinkLightActiveBackground",
              "attributes": {
                "category": "color",
                "type": "tag",
                "item": "link",
                "subitem": "light",
                "state": "active"
              },
              "path": [
                "color",
                "tag",
                "link",
                "light",
                "active",
                "background"
              ]
            }
          }
        },
        "dark": {
          "background": {
            "value": "#000000",
            "original": {
              "value": "{color.grey.999.value}"
            },
            "name": "ColorTagLinkDarkBackground",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "link",
              "subitem": "dark",
              "state": "background"
            },
            "path": [
              "color",
              "tag",
              "link",
              "dark",
              "background"
            ]
          },
          "border": {
            "value": "#ffffff",
            "original": {
              "value": "{color.grey.000.value}"
            },
            "name": "ColorTagLinkDarkBorder",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "link",
              "subitem": "dark",
              "state": "border"
            },
            "path": [
              "color",
              "tag",
              "link",
              "dark",
              "border"
            ]
          },
          "text": {
            "value": "#ffffff",
            "original": {
              "value": "{color.grey.000.value}"
            },
            "name": "ColorTagLinkDarkText",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "link",
              "subitem": "dark",
              "state": "text"
            },
            "path": [
              "color",
              "tag",
              "link",
              "dark",
              "text"
            ]
          },
          "hover": {
            "background": {
              "value": "#3c3738",
              "original": {
                "value": "{color.grey.800.value}"
              },
              "name": "ColorTagLinkDarkHoverBackground",
              "attributes": {
                "category": "color",
                "type": "tag",
                "item": "link",
                "subitem": "dark",
                "state": "hover"
              },
              "path": [
                "color",
                "tag",
                "link",
                "dark",
                "hover",
                "background"
              ]
            }
          },
          "active": {
            "background": {
              "value": "#554f52",
              "original": {
                "value": "{color.grey.700.value}"
              },
              "name": "ColorTagLinkDarkActiveBackground",
              "attributes": {
                "category": "color",
                "type": "tag",
                "item": "link",
                "subitem": "dark",
                "state": "active"
              },
              "path": [
                "color",
                "tag",
                "link",
                "dark",
                "active",
                "background"
              ]
            }
          }
        }
      },
      "selectable": {
        "light": {
          "background": {
            "value": "#d3d2d6",
            "original": {
              "value": "{color.grey.200.value}"
            },
            "name": "ColorTagSelectableLightBackground",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "selectable",
              "subitem": "light",
              "state": "background"
            },
            "path": [
              "color",
              "tag",
              "selectable",
              "light",
              "background"
            ]
          },
          "text": {
            "value": "#222020",
            "original": {
              "value": "{color.grey.900.value}"
            },
            "name": "ColorTagSelectableLightText",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "selectable",
              "subitem": "light",
              "state": "text"
            },
            "path": [
              "color",
              "tag",
              "selectable",
              "light",
              "text"
            ]
          },
          "hover": {
            "background": {
              "value": "#add585",
              "original": {
                "value": "{color.primary-01.300.value}"
              },
              "name": "ColorTagSelectableLightHoverBackground",
              "attributes": {
                "category": "color",
                "type": "tag",
                "item": "selectable",
                "subitem": "light",
                "state": "hover"
              },
              "path": [
                "color",
                "tag",
                "selectable",
                "light",
                "hover",
                "background"
              ]
            }
          },
          "active": {
            "background": {
              "value": "#41a017",
              "original": {
                "value": "{color.primary-01.600.value}"
              },
              "name": "ColorTagSelectableLightActiveBackground",
              "attributes": {
                "category": "color",
                "type": "tag",
                "item": "selectable",
                "subitem": "light",
                "state": "active"
              },
              "path": [
                "color",
                "tag",
                "selectable",
                "light",
                "active",
                "background"
              ]
            }
          },
          "disabled": {
            "background": {
              "value": "#eeeef0",
              "original": {
                "value": "{color.grey.100.value}"
              },
              "name": "ColorTagSelectableLightDisabledBackground",
              "attributes": {
                "category": "color",
                "type": "tag",
                "item": "selectable",
                "subitem": "light",
                "state": "disabled"
              },
              "path": [
                "color",
                "tag",
                "selectable",
                "light",
                "disabled",
                "background"
              ]
            },
            "text": {
              "value": "#887f87",
              "original": {
                "value": "{color.grey.500.value}"
              },
              "name": "ColorTagSelectableLightDisabledText",
              "attributes": {
                "category": "color",
                "type": "tag",
                "item": "selectable",
                "subitem": "light",
                "state": "disabled"
              },
              "path": [
                "color",
                "tag",
                "selectable",
                "light",
                "disabled",
                "text"
              ]
            }
          },
          "selected": {
            "background": {
              "value": "#78be20",
              "original": {
                "value": "{color.primary-01.500.value}"
              },
              "name": "ColorTagSelectableLightSelectedBackground",
              "attributes": {
                "category": "color",
                "type": "tag",
                "item": "selectable",
                "subitem": "light",
                "state": "selected"
              },
              "path": [
                "color",
                "tag",
                "selectable",
                "light",
                "selected",
                "background"
              ]
            }
          }
        },
        "dark": {
          "background": {
            "value": "#3c3738",
            "original": {
              "value": "{color.grey.800.value}"
            },
            "name": "ColorTagSelectableDarkBackground",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "selectable",
              "subitem": "dark",
              "state": "background"
            },
            "path": [
              "color",
              "tag",
              "selectable",
              "dark",
              "background"
            ]
          },
          "text": {
            "value": "#ffffff",
            "original": {
              "value": "{color.grey.000.value}"
            },
            "name": "ColorTagSelectableDarkText",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "selectable",
              "subitem": "dark",
              "state": "text"
            },
            "path": [
              "color",
              "tag",
              "selectable",
              "dark",
              "text"
            ]
          },
          "hover": {
            "background": {
              "value": "#78be20",
              "original": {
                "value": "{color.primary-01.500.value}"
              },
              "name": "ColorTagSelectableDarkHoverBackground",
              "attributes": {
                "category": "color",
                "type": "tag",
                "item": "selectable",
                "subitem": "dark",
                "state": "hover"
              },
              "path": [
                "color",
                "tag",
                "selectable",
                "dark",
                "hover",
                "background"
              ]
            }
          },
          "active": {
            "background": {
              "value": "#0a601b",
              "original": {
                "value": "{color.primary-01.800.value}"
              },
              "name": "ColorTagSelectableDarkActiveBackground",
              "attributes": {
                "category": "color",
                "type": "tag",
                "item": "selectable",
                "subitem": "dark",
                "state": "active"
              },
              "path": [
                "color",
                "tag",
                "selectable",
                "dark",
                "active",
                "background"
              ]
            }
          },
          "selected": {
            "background": {
              "value": "#158110",
              "original": {
                "value": "{color.primary-01.700.value}"
              },
              "name": "ColorTagSelectableDarkSelectedBackground",
              "attributes": {
                "category": "color",
                "type": "tag",
                "item": "selectable",
                "subitem": "dark",
                "state": "selected"
              },
              "path": [
                "color",
                "tag",
                "selectable",
                "dark",
                "selected",
                "background"
              ]
            }
          },
          "disabled": {
            "background": {
              "value": "#554f52",
              "original": {
                "value": "{color.grey.700.value}"
              },
              "name": "ColorTagSelectableDarkDisabledBackground",
              "attributes": {
                "category": "color",
                "type": "tag",
                "item": "selectable",
                "subitem": "dark",
                "state": "disabled"
              },
              "path": [
                "color",
                "tag",
                "selectable",
                "dark",
                "disabled",
                "background"
              ]
            },
            "text": {
              "value": "#887f87",
              "original": {
                "value": "{color.grey.500.value}"
              },
              "name": "ColorTagSelectableDarkDisabledText",
              "attributes": {
                "category": "color",
                "type": "tag",
                "item": "selectable",
                "subitem": "dark",
                "state": "disabled"
              },
              "path": [
                "color",
                "tag",
                "selectable",
                "dark",
                "disabled",
                "text"
              ]
            }
          }
        }
      },
      "removable": {
        "light": {
          "background": {
            "value": "#d3d2d6",
            "original": {
              "value": "{color.grey.200.value}"
            },
            "name": "ColorTagRemovableLightBackground",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "removable",
              "subitem": "light",
              "state": "background"
            },
            "path": [
              "color",
              "tag",
              "removable",
              "light",
              "background"
            ]
          },
          "text": {
            "value": "#222020",
            "original": {
              "value": "{color.grey.900.value}"
            },
            "name": "ColorTagRemovableLightText",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "removable",
              "subitem": "light",
              "state": "text"
            },
            "path": [
              "color",
              "tag",
              "removable",
              "light",
              "text"
            ]
          },
          "icon": {
            "value": "#3c3738",
            "original": {
              "value": "{color.grey.800.value}"
            },
            "name": "ColorTagRemovableLightIcon",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "removable",
              "subitem": "light",
              "state": "icon"
            },
            "path": [
              "color",
              "tag",
              "removable",
              "light",
              "icon"
            ]
          },
          "hover": {
            "background": {
              "value": "#bab6bc",
              "original": {
                "value": "{color.grey.300.value}"
              },
              "name": "ColorTagRemovableLightHoverBackground",
              "attributes": {
                "category": "color",
                "type": "tag",
                "item": "removable",
                "subitem": "light",
                "state": "hover"
              },
              "path": [
                "color",
                "tag",
                "removable",
                "light",
                "hover",
                "background"
              ]
            }
          },
          "active": {
            "background": {
              "value": "#a19ba2",
              "original": {
                "value": "{color.grey.400.value}"
              },
              "name": "ColorTagRemovableLightActiveBackground",
              "attributes": {
                "category": "color",
                "type": "tag",
                "item": "removable",
                "subitem": "light",
                "state": "active"
              },
              "path": [
                "color",
                "tag",
                "removable",
                "light",
                "active",
                "background"
              ]
            }
          }
        },
        "dark": {
          "background": {
            "value": "#3c3738",
            "original": {
              "value": "{color.grey.800.value}"
            },
            "name": "ColorTagRemovableDarkBackground",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "removable",
              "subitem": "dark",
              "state": "background"
            },
            "path": [
              "color",
              "tag",
              "removable",
              "dark",
              "background"
            ]
          },
          "text": {
            "value": "#ffffff",
            "original": {
              "value": "{color.grey.000.value}"
            },
            "name": "ColorTagRemovableDarkText",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "removable",
              "subitem": "dark",
              "state": "text"
            },
            "path": [
              "color",
              "tag",
              "removable",
              "dark",
              "text"
            ]
          },
          "icon": {
            "value": "#d3d2d6",
            "original": {
              "value": "{color.grey.200.value}"
            },
            "name": "ColorTagRemovableDarkIcon",
            "attributes": {
              "category": "color",
              "type": "tag",
              "item": "removable",
              "subitem": "dark",
              "state": "icon"
            },
            "path": [
              "color",
              "tag",
              "removable",
              "dark",
              "icon"
            ]
          },
          "hover": {
            "background": {
              "value": "#554f52",
              "original": {
                "value": "{color.grey.700.value}"
              },
              "name": "ColorTagRemovableDarkHoverBackground",
              "attributes": {
                "category": "color",
                "type": "tag",
                "item": "removable",
                "subitem": "dark",
                "state": "hover"
              },
              "path": [
                "color",
                "tag",
                "removable",
                "dark",
                "hover",
                "background"
              ]
            }
          },
          "active": {
            "background": {
              "value": "#6f676c",
              "original": {
                "value": "{color.grey.600.value}"
              },
              "name": "ColorTagRemovableDarkActiveBackground",
              "attributes": {
                "category": "color",
                "type": "tag",
                "item": "removable",
                "subitem": "dark",
                "state": "active"
              },
              "path": [
                "color",
                "tag",
                "removable",
                "dark",
                "active",
                "background"
              ]
            }
          }
        }
      }
    },
    "toggle": {
      "off": {
        "background": {
          "value": "#887f87",
          "original": {
            "value": "{color.grey.500.value}"
          },
          "name": "ColorToggleOffBackground",
          "attributes": {
            "category": "color",
            "type": "toggle",
            "item": "off",
            "subitem": "background"
          },
          "path": [
            "color",
            "toggle",
            "off",
            "background"
          ]
        },
        "circle": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorToggleOffCircle",
          "attributes": {
            "category": "color",
            "type": "toggle",
            "item": "off",
            "subitem": "circle"
          },
          "path": [
            "color",
            "toggle",
            "off",
            "circle"
          ]
        }
      },
      "on": {
        "background": {
          "value": "#78be20",
          "original": {
            "value": "{color.primary-01.500.value}"
          },
          "name": "ColorToggleOnBackground",
          "attributes": {
            "category": "color",
            "type": "toggle",
            "item": "on",
            "subitem": "background"
          },
          "path": [
            "color",
            "toggle",
            "on",
            "background"
          ]
        },
        "circle": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorToggleOnCircle",
          "attributes": {
            "category": "color",
            "type": "toggle",
            "item": "on",
            "subitem": "circle"
          },
          "path": [
            "color",
            "toggle",
            "on",
            "circle"
          ]
        }
      },
      "hover": {
        "circle": {
          "value": "#eeeef0",
          "original": {
            "value": "{color.grey.100.value}"
          },
          "name": "ColorToggleHoverCircle",
          "attributes": {
            "category": "color",
            "type": "toggle",
            "item": "hover",
            "subitem": "circle"
          },
          "path": [
            "color",
            "toggle",
            "hover",
            "circle"
          ]
        }
      },
      "disabled": {
        "background": {
          "value": "#eeeef0",
          "original": {
            "value": "{color.input.disabled.background.value}"
          },
          "name": "ColorToggleDisabledBackground",
          "attributes": {
            "category": "color",
            "type": "toggle",
            "item": "disabled",
            "subitem": "background"
          },
          "path": [
            "color",
            "toggle",
            "disabled",
            "background"
          ]
        },
        "circle": {
          "value": "#bab6bc",
          "original": {
            "value": "{color.grey.300.value}"
          },
          "name": "ColorToggleDisabledCircle",
          "attributes": {
            "category": "color",
            "type": "toggle",
            "item": "disabled",
            "subitem": "circle"
          },
          "path": [
            "color",
            "toggle",
            "disabled",
            "circle"
          ]
        }
      },
      "disabled-checked": {
        "background": {
          "value": "#cbe3b5",
          "original": {
            "value": "{color.primary-01.200.value}"
          },
          "name": "ColorToggleDisabledCheckedBackground",
          "attributes": {
            "category": "color",
            "type": "toggle",
            "item": "disabled-checked",
            "subitem": "background"
          },
          "path": [
            "color",
            "toggle",
            "disabled-checked",
            "background"
          ]
        },
        "circle": {
          "value": "#ffffff",
          "original": {
            "value": "{color.grey.000.value}"
          },
          "name": "ColorToggleDisabledCheckedCircle",
          "attributes": {
            "category": "color",
            "type": "toggle",
            "item": "disabled-checked",
            "subitem": "circle"
          },
          "path": [
            "color",
            "toggle",
            "disabled-checked",
            "circle"
          ]
        }
      }
    }
  },
  "preset": {
    "value": "lm",
    "original": {
      "value": "lm"
    },
    "name": "Preset",
    "attributes": {
      "category": "preset"
    },
    "path": [
      "preset"
    ]
  },
  "radius": {
    "s": {
      "value": 2,
      "original": {
        "value": 2
      },
      "name": "RadiusS",
      "attributes": {
        "category": "radius",
        "type": "s"
      },
      "path": [
        "radius",
        "s"
      ]
    },
    "m": {
      "value": 4,
      "original": {
        "value": 4
      },
      "name": "RadiusM",
      "attributes": {
        "category": "radius",
        "type": "m"
      },
      "path": [
        "radius",
        "m"
      ]
    },
    "l": {
      "value": 6,
      "original": {
        "value": 6
      },
      "name": "RadiusL",
      "attributes": {
        "category": "radius",
        "type": "l"
      },
      "path": [
        "radius",
        "l"
      ]
    }
  },
  "shadow": {
    "s": {
      "x": {
        "value": "0px",
        "original": {
          "value": "0px"
        },
        "name": "ShadowSX",
        "attributes": {
          "category": "shadow",
          "type": "s",
          "item": "x"
        },
        "path": [
          "shadow",
          "s",
          "x"
        ]
      },
      "y": {
        "value": "1px",
        "original": {
          "value": "1px"
        },
        "name": "ShadowSY",
        "attributes": {
          "category": "shadow",
          "type": "s",
          "item": "y"
        },
        "path": [
          "shadow",
          "s",
          "y"
        ]
      },
      "blur": {
        "value": "5px",
        "original": {
          "value": "5px"
        },
        "name": "ShadowSBlur",
        "attributes": {
          "category": "shadow",
          "type": "s",
          "item": "blur"
        },
        "path": [
          "shadow",
          "s",
          "blur"
        ]
      },
      "spread": {
        "value": "0px",
        "original": {
          "value": "0px"
        },
        "name": "ShadowSSpread",
        "attributes": {
          "category": "shadow",
          "type": "s",
          "item": "spread"
        },
        "path": [
          "shadow",
          "s",
          "spread"
        ]
      },
      "opacity": {
        "value": "0.2",
        "original": {
          "value": "0.2"
        },
        "name": "ShadowSOpacity",
        "attributes": {
          "category": "shadow",
          "type": "s",
          "item": "opacity"
        },
        "path": [
          "shadow",
          "s",
          "opacity"
        ]
      }
    },
    "m": {
      "x": {
        "value": "0px",
        "original": {
          "value": "0px"
        },
        "name": "ShadowMX",
        "attributes": {
          "category": "shadow",
          "type": "m",
          "item": "x"
        },
        "path": [
          "shadow",
          "m",
          "x"
        ]
      },
      "y": {
        "value": "2px",
        "original": {
          "value": "2px"
        },
        "name": "ShadowMY",
        "attributes": {
          "category": "shadow",
          "type": "m",
          "item": "y"
        },
        "path": [
          "shadow",
          "m",
          "y"
        ]
      },
      "blur": {
        "value": "10px",
        "original": {
          "value": "10px"
        },
        "name": "ShadowMBlur",
        "attributes": {
          "category": "shadow",
          "type": "m",
          "item": "blur"
        },
        "path": [
          "shadow",
          "m",
          "blur"
        ]
      },
      "spread": {
        "value": "0px",
        "original": {
          "value": "0px"
        },
        "name": "ShadowMSpread",
        "attributes": {
          "category": "shadow",
          "type": "m",
          "item": "spread"
        },
        "path": [
          "shadow",
          "m",
          "spread"
        ]
      },
      "opacity": {
        "value": "0.2",
        "original": {
          "value": "0.2"
        },
        "name": "ShadowMOpacity",
        "attributes": {
          "category": "shadow",
          "type": "m",
          "item": "opacity"
        },
        "path": [
          "shadow",
          "m",
          "opacity"
        ]
      }
    },
    "l": {
      "x": {
        "value": "0px",
        "original": {
          "value": "0px"
        },
        "name": "ShadowLX",
        "attributes": {
          "category": "shadow",
          "type": "l",
          "item": "x"
        },
        "path": [
          "shadow",
          "l",
          "x"
        ]
      },
      "y": {
        "value": "4px",
        "original": {
          "value": "4px"
        },
        "name": "ShadowLY",
        "attributes": {
          "category": "shadow",
          "type": "l",
          "item": "y"
        },
        "path": [
          "shadow",
          "l",
          "y"
        ]
      },
      "blur": {
        "value": "20px",
        "original": {
          "value": "20px"
        },
        "name": "ShadowLBlur",
        "attributes": {
          "category": "shadow",
          "type": "l",
          "item": "blur"
        },
        "path": [
          "shadow",
          "l",
          "blur"
        ]
      },
      "spread": {
        "value": "0px",
        "original": {
          "value": "0px"
        },
        "name": "ShadowLSpread",
        "attributes": {
          "category": "shadow",
          "type": "l",
          "item": "spread"
        },
        "path": [
          "shadow",
          "l",
          "spread"
        ]
      },
      "opacity": {
        "value": "0.2",
        "original": {
          "value": "0.2"
        },
        "name": "ShadowLOpacity",
        "attributes": {
          "category": "shadow",
          "type": "l",
          "item": "opacity"
        },
        "path": [
          "shadow",
          "l",
          "opacity"
        ]
      }
    }
  },
  "magic-unit": {
    "value": 1,
    "original": {
      "value": 1
    },
    "name": "MagicUnit",
    "attributes": {
      "category": "magic-unit"
    },
    "path": [
      "magic-unit"
    ]
  },
  "local-rem-value": {
    "value": 16,
    "original": {
      "value": 16
    },
    "name": "LocalRemValue",
    "attributes": {
      "category": "local-rem-value"
    },
    "path": [
      "local-rem-value"
    ]
  },
  "size": {
    "font": {
      "10": {
        "value": "2.5625rem",
        "comment": "41px",
        "original": {
          "value": 2.5625,
          "comment": "41px"
        },
        "name": "SizeFont10",
        "attributes": {
          "category": "size",
          "type": "font",
          "item": "10"
        },
        "path": [
          "size",
          "font",
          "10"
        ]
      },
      "11": {
        "value": "3.0625rem",
        "comment": "49px",
        "original": {
          "value": 3.0625,
          "comment": "49px"
        },
        "name": "SizeFont11",
        "attributes": {
          "category": "size",
          "type": "font",
          "item": "11"
        },
        "path": [
          "size",
          "font",
          "11"
        ]
      },
      "12": {
        "value": "3.6875rem",
        "comment": "59px",
        "original": {
          "value": 3.6875,
          "comment": "59px"
        },
        "name": "SizeFont12",
        "attributes": {
          "category": "size",
          "type": "font",
          "item": "12"
        },
        "path": [
          "size",
          "font",
          "12"
        ]
      },
      "01": {
        "value": "0.6815rem",
        "comment": "11px",
        "original": {
          "value": 0.6815,
          "comment": "11px"
        },
        "name": "SizeFont01",
        "attributes": {
          "category": "size",
          "type": "font",
          "item": "01"
        },
        "path": [
          "size",
          "font",
          "01"
        ]
      },
      "02": {
        "value": "0.75rem",
        "comment": "12px",
        "original": {
          "value": 0.75,
          "comment": "12px"
        },
        "name": "SizeFont02",
        "attributes": {
          "category": "size",
          "type": "font",
          "item": "02"
        },
        "path": [
          "size",
          "font",
          "02"
        ]
      },
      "03": {
        "value": "0.8125rem",
        "comment": "13px",
        "original": {
          "value": 0.8125,
          "comment": "13px"
        },
        "name": "SizeFont03",
        "attributes": {
          "category": "size",
          "type": "font",
          "item": "03"
        },
        "path": [
          "size",
          "font",
          "03"
        ]
      },
      "04": {
        "value": "0.875rem",
        "comment": "14px",
        "original": {
          "value": 0.875,
          "comment": "14px"
        },
        "name": "SizeFont04",
        "attributes": {
          "category": "size",
          "type": "font",
          "item": "04"
        },
        "path": [
          "size",
          "font",
          "04"
        ]
      },
      "05": {
        "value": "1rem",
        "comment": "16px",
        "original": {
          "value": 1,
          "comment": "16px"
        },
        "name": "SizeFont05",
        "attributes": {
          "category": "size",
          "type": "font",
          "item": "05"
        },
        "path": [
          "size",
          "font",
          "05"
        ]
      },
      "06": {
        "value": "1.125rem",
        "comment": "18px",
        "original": {
          "value": 1.125,
          "comment": "18px"
        },
        "name": "SizeFont06",
        "attributes": {
          "category": "size",
          "type": "font",
          "item": "06"
        },
        "path": [
          "size",
          "font",
          "06"
        ]
      },
      "07": {
        "value": "1.4375rem",
        "comment": "23px",
        "original": {
          "value": 1.4375,
          "comment": "23px"
        },
        "name": "SizeFont07",
        "attributes": {
          "category": "size",
          "type": "font",
          "item": "07"
        },
        "path": [
          "size",
          "font",
          "07"
        ]
      },
      "08": {
        "value": "1.75rem",
        "comment": "28px",
        "original": {
          "value": 1.75,
          "comment": "28px"
        },
        "name": "SizeFont08",
        "attributes": {
          "category": "size",
          "type": "font",
          "item": "08"
        },
        "path": [
          "size",
          "font",
          "08"
        ]
      },
      "09": {
        "value": "2.125rem",
        "comment": "34px",
        "original": {
          "value": 2.125,
          "comment": "34px"
        },
        "name": "SizeFont09",
        "attributes": {
          "category": "size",
          "type": "font",
          "item": "09"
        },
        "path": [
          "size",
          "font",
          "09"
        ]
      }
    },
    "line": {
      "10": {
        "xs": {
          "value": "2.5rem",
          "comment": "40px",
          "original": {
            "value": 2.5,
            "comment": "40px"
          },
          "name": "SizeLine10Xs",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "10",
            "subitem": "xs"
          },
          "path": [
            "size",
            "line",
            "10",
            "xs"
          ]
        },
        "s": {
          "value": "3rem",
          "comment": "48px",
          "original": {
            "value": 3,
            "comment": "48px"
          },
          "name": "SizeLine10S",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "10",
            "subitem": "s"
          },
          "path": [
            "size",
            "line",
            "10",
            "s"
          ]
        },
        "m": {
          "value": "3.5rem",
          "comment": "56px",
          "original": {
            "value": 3.5,
            "comment": "56px"
          },
          "name": "SizeLine10M",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "10",
            "subitem": "m"
          },
          "path": [
            "size",
            "line",
            "10",
            "m"
          ]
        },
        "l": {
          "value": "3.75rem",
          "comment": "60px",
          "original": {
            "value": 3.75,
            "comment": "60px"
          },
          "name": "SizeLine10L",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "10",
            "subitem": "l"
          },
          "path": [
            "size",
            "line",
            "10",
            "l"
          ]
        }
      },
      "11": {
        "xs": {
          "value": "3rem",
          "comment": "48px",
          "original": {
            "value": 3,
            "comment": "48px"
          },
          "name": "SizeLine11Xs",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "11",
            "subitem": "xs"
          },
          "path": [
            "size",
            "line",
            "11",
            "xs"
          ]
        },
        "s": {
          "value": "3.5rem",
          "comment": "56px",
          "original": {
            "value": 3.5,
            "comment": "56px"
          },
          "name": "SizeLine11S",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "11",
            "subitem": "s"
          },
          "path": [
            "size",
            "line",
            "11",
            "s"
          ]
        },
        "m": {
          "value": "4.25rem",
          "comment": "68px",
          "original": {
            "value": 4.25,
            "comment": "68px"
          },
          "name": "SizeLine11M",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "11",
            "subitem": "m"
          },
          "path": [
            "size",
            "line",
            "11",
            "m"
          ]
        },
        "l": {
          "value": "4.5rem",
          "comment": "72px",
          "original": {
            "value": 4.5,
            "comment": "72px"
          },
          "name": "SizeLine11L",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "11",
            "subitem": "l"
          },
          "path": [
            "size",
            "line",
            "11",
            "l"
          ]
        }
      },
      "12": {
        "xs": {
          "value": "3.75rem",
          "comment": "60px",
          "original": {
            "value": 3.75,
            "comment": "60px"
          },
          "name": "SizeLine12Xs",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "12",
            "subitem": "xs"
          },
          "path": [
            "size",
            "line",
            "12",
            "xs"
          ]
        },
        "s": {
          "value": "4.25rem",
          "comment": "68px",
          "original": {
            "value": 4.25,
            "comment": "68px"
          },
          "name": "SizeLine12S",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "12",
            "subitem": "s"
          },
          "path": [
            "size",
            "line",
            "12",
            "s"
          ]
        },
        "m": {
          "value": "5rem",
          "comment": "80px",
          "original": {
            "value": 5,
            "comment": "80px"
          },
          "name": "SizeLine12M",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "12",
            "subitem": "m"
          },
          "path": [
            "size",
            "line",
            "12",
            "m"
          ]
        },
        "l": {
          "value": "5.5rem",
          "comment": "88px",
          "original": {
            "value": 5.5,
            "comment": "88px"
          },
          "name": "SizeLine12L",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "12",
            "subitem": "l"
          },
          "path": [
            "size",
            "line",
            "12",
            "l"
          ]
        }
      },
      "01": {
        "xs": {
          "value": "0.75rem",
          "comment": "12px",
          "original": {
            "value": 0.75,
            "comment": "12px"
          },
          "name": "SizeLine01Xs",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "01",
            "subitem": "xs"
          },
          "path": [
            "size",
            "line",
            "01",
            "xs"
          ]
        },
        "s": {
          "value": "0.75rem",
          "comment": "12px",
          "original": {
            "value": 0.75,
            "comment": "12px"
          },
          "name": "SizeLine01S",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "01",
            "subitem": "s"
          },
          "path": [
            "size",
            "line",
            "01",
            "s"
          ]
        },
        "m": {
          "value": "0.875rem",
          "comment": "14px",
          "original": {
            "value": 0.875,
            "comment": "14px"
          },
          "name": "SizeLine01M",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "01",
            "subitem": "m"
          },
          "path": [
            "size",
            "line",
            "01",
            "m"
          ]
        },
        "l": {
          "value": "1rem",
          "comment": "16px",
          "original": {
            "value": 1,
            "comment": "16px"
          },
          "name": "SizeLine01L",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "01",
            "subitem": "l"
          },
          "path": [
            "size",
            "line",
            "01",
            "l"
          ]
        }
      },
      "02": {
        "xs": {
          "value": "0.75rem",
          "comment": "12px",
          "original": {
            "value": 0.75,
            "comment": "12px"
          },
          "name": "SizeLine02Xs",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "02",
            "subitem": "xs"
          },
          "path": [
            "size",
            "line",
            "02",
            "xs"
          ]
        },
        "s": {
          "value": "0.875rem",
          "comment": "14px",
          "original": {
            "value": 0.875,
            "comment": "14px"
          },
          "name": "SizeLine02S",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "02",
            "subitem": "s"
          },
          "path": [
            "size",
            "line",
            "02",
            "s"
          ]
        },
        "m": {
          "value": "1rem",
          "comment": "16px",
          "original": {
            "value": 1,
            "comment": "16px"
          },
          "name": "SizeLine02M",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "02",
            "subitem": "m"
          },
          "path": [
            "size",
            "line",
            "02",
            "m"
          ]
        },
        "l": {
          "value": "1.125rem",
          "comment": "18px",
          "original": {
            "value": 1.125,
            "comment": "18px"
          },
          "name": "SizeLine02L",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "02",
            "subitem": "l"
          },
          "path": [
            "size",
            "line",
            "02",
            "l"
          ]
        }
      },
      "03": {
        "xs": {
          "value": "0.875rem",
          "comment": "14px",
          "original": {
            "value": 0.875,
            "comment": "14px"
          },
          "name": "SizeLine03Xs",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "03",
            "subitem": "xs"
          },
          "path": [
            "size",
            "line",
            "03",
            "xs"
          ]
        },
        "s": {
          "value": "1rem",
          "comment": "16px",
          "original": {
            "value": 1,
            "comment": "16px"
          },
          "name": "SizeLine03S",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "03",
            "subitem": "s"
          },
          "path": [
            "size",
            "line",
            "03",
            "s"
          ]
        },
        "m": {
          "value": "1.125rem",
          "comment": "18px",
          "original": {
            "value": 1.125,
            "comment": "18px"
          },
          "name": "SizeLine03M",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "03",
            "subitem": "m"
          },
          "path": [
            "size",
            "line",
            "03",
            "m"
          ]
        },
        "l": {
          "value": "1.25rem",
          "comment": "20px",
          "original": {
            "value": 1.25,
            "comment": "20px"
          },
          "name": "SizeLine03L",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "03",
            "subitem": "l"
          },
          "path": [
            "size",
            "line",
            "03",
            "l"
          ]
        }
      },
      "04": {
        "xs": {
          "value": "0.875rem",
          "comment": "14px",
          "original": {
            "value": 0.875,
            "comment": "14px"
          },
          "name": "SizeLine04Xs",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "04",
            "subitem": "xs"
          },
          "path": [
            "size",
            "line",
            "04",
            "xs"
          ]
        },
        "s": {
          "value": "1rem",
          "comment": "16px",
          "original": {
            "value": 1,
            "comment": "16px"
          },
          "name": "SizeLine04S",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "04",
            "subitem": "s"
          },
          "path": [
            "size",
            "line",
            "04",
            "s"
          ]
        },
        "m": {
          "value": "1.125rem",
          "comment": "18px",
          "original": {
            "value": 1.125,
            "comment": "18px"
          },
          "name": "SizeLine04M",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "04",
            "subitem": "m"
          },
          "path": [
            "size",
            "line",
            "04",
            "m"
          ]
        },
        "l": {
          "value": "1.375rem",
          "comment": "22px",
          "original": {
            "value": 1.375,
            "comment": "22px"
          },
          "name": "SizeLine04L",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "04",
            "subitem": "l"
          },
          "path": [
            "size",
            "line",
            "04",
            "l"
          ]
        }
      },
      "05": {
        "xs": {
          "value": "1rem",
          "comment": "16px",
          "original": {
            "value": 1,
            "comment": "16px"
          },
          "name": "SizeLine05Xs",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "05",
            "subitem": "xs"
          },
          "path": [
            "size",
            "line",
            "05",
            "xs"
          ]
        },
        "s": {
          "value": "1.125rem",
          "comment": "18px",
          "original": {
            "value": 1.125,
            "comment": "18px"
          },
          "name": "SizeLine05S",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "05",
            "subitem": "s"
          },
          "path": [
            "size",
            "line",
            "05",
            "s"
          ]
        },
        "m": {
          "value": "1.375rem",
          "comment": "22px",
          "original": {
            "value": 1.375,
            "comment": "22px"
          },
          "name": "SizeLine05M",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "05",
            "subitem": "m"
          },
          "path": [
            "size",
            "line",
            "05",
            "m"
          ]
        },
        "l": {
          "value": "1.5rem",
          "comment": "24px",
          "original": {
            "value": 1.5,
            "comment": "24px"
          },
          "name": "SizeLine05L",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "05",
            "subitem": "l"
          },
          "path": [
            "size",
            "line",
            "05",
            "l"
          ]
        }
      },
      "06": {
        "xs": {
          "value": "1.125rem",
          "comment": "18px",
          "original": {
            "value": 1.125,
            "comment": "18px"
          },
          "name": "SizeLine06Xs",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "06",
            "subitem": "xs"
          },
          "path": [
            "size",
            "line",
            "06",
            "xs"
          ]
        },
        "s": {
          "value": "1.25rem",
          "comment": "20px",
          "original": {
            "value": 1.25,
            "comment": "20px"
          },
          "name": "SizeLine06S",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "06",
            "subitem": "s"
          },
          "path": [
            "size",
            "line",
            "06",
            "s"
          ]
        },
        "m": {
          "value": "1.5rem",
          "comment": "24px",
          "original": {
            "value": 1.5,
            "comment": "24px"
          },
          "name": "SizeLine06M",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "06",
            "subitem": "m"
          },
          "path": [
            "size",
            "line",
            "06",
            "m"
          ]
        },
        "l": {
          "value": "1.75rem",
          "comment": "28px",
          "original": {
            "value": 1.75,
            "comment": "28px"
          },
          "name": "SizeLine06L",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "06",
            "subitem": "l"
          },
          "path": [
            "size",
            "line",
            "06",
            "l"
          ]
        }
      },
      "07": {
        "xs": {
          "value": "1.5rem",
          "comment": "24px",
          "original": {
            "value": 1.5,
            "comment": "24px"
          },
          "name": "SizeLine07Xs",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "07",
            "subitem": "xs"
          },
          "path": [
            "size",
            "line",
            "07",
            "xs"
          ]
        },
        "s": {
          "value": "1.75rem",
          "comment": "28px",
          "original": {
            "value": 1.75,
            "comment": "28px"
          },
          "name": "SizeLine07S",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "07",
            "subitem": "s"
          },
          "path": [
            "size",
            "line",
            "07",
            "s"
          ]
        },
        "m": {
          "value": "2rem",
          "comment": "32px",
          "original": {
            "value": 2,
            "comment": "32px"
          },
          "name": "SizeLine07M",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "07",
            "subitem": "m"
          },
          "path": [
            "size",
            "line",
            "07",
            "m"
          ]
        },
        "l": {
          "value": "2.25rem",
          "comment": "36px",
          "original": {
            "value": 2.25,
            "comment": "36px"
          },
          "name": "SizeLine07L",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "07",
            "subitem": "l"
          },
          "path": [
            "size",
            "line",
            "07",
            "l"
          ]
        }
      },
      "08": {
        "xs": {
          "value": "1.75rem",
          "comment": "28px",
          "original": {
            "value": 1.75,
            "comment": "28px"
          },
          "name": "SizeLine08Xs",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "08",
            "subitem": "xs"
          },
          "path": [
            "size",
            "line",
            "08",
            "xs"
          ]
        },
        "s": {
          "value": "2rem",
          "comment": "32px",
          "original": {
            "value": 2,
            "comment": "32px"
          },
          "name": "SizeLine08S",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "08",
            "subitem": "s"
          },
          "path": [
            "size",
            "line",
            "08",
            "s"
          ]
        },
        "m": {
          "value": "2.25rem",
          "comment": "36px",
          "original": {
            "value": 2.25,
            "comment": "36px"
          },
          "name": "SizeLine08M",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "08",
            "subitem": "m"
          },
          "path": [
            "size",
            "line",
            "08",
            "m"
          ]
        },
        "l": {
          "value": "2.75rem",
          "comment": "44px",
          "original": {
            "value": 2.75,
            "comment": "44px"
          },
          "name": "SizeLine08L",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "08",
            "subitem": "l"
          },
          "path": [
            "size",
            "line",
            "08",
            "l"
          ]
        }
      },
      "09": {
        "xs": {
          "value": "2.25rem",
          "comment": "36px",
          "original": {
            "value": 2.25,
            "comment": "36px"
          },
          "name": "SizeLine09Xs",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "09",
            "subitem": "xs"
          },
          "path": [
            "size",
            "line",
            "09",
            "xs"
          ]
        },
        "s": {
          "value": "2.5rem",
          "comment": "40px",
          "original": {
            "value": 2.5,
            "comment": "40px"
          },
          "name": "SizeLine09S",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "09",
            "subitem": "s"
          },
          "path": [
            "size",
            "line",
            "09",
            "s"
          ]
        },
        "m": {
          "value": "2.75rem",
          "comment": "44px",
          "original": {
            "value": 2.75,
            "comment": "44px"
          },
          "name": "SizeLine09M",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "09",
            "subitem": "m"
          },
          "path": [
            "size",
            "line",
            "09",
            "m"
          ]
        },
        "l": {
          "value": "3.25rem",
          "comment": "52px",
          "original": {
            "value": 3.25,
            "comment": "52px"
          },
          "name": "SizeLine09L",
          "attributes": {
            "category": "size",
            "type": "line",
            "item": "09",
            "subitem": "l"
          },
          "path": [
            "size",
            "line",
            "09",
            "l"
          ]
        }
      }
    },
    "gutter": {
      "screen": {
        "s": {
          "value": "1rem",
          "original": {
            "value": 1
          },
          "name": "SizeGutterScreenS",
          "attributes": {
            "category": "size",
            "type": "gutter",
            "item": "screen",
            "subitem": "s"
          },
          "path": [
            "size",
            "gutter",
            "screen",
            "s"
          ]
        },
        "m": {
          "value": "2rem",
          "original": {
            "value": 2
          },
          "name": "SizeGutterScreenM",
          "attributes": {
            "category": "size",
            "type": "gutter",
            "item": "screen",
            "subitem": "m"
          },
          "path": [
            "size",
            "gutter",
            "screen",
            "m"
          ]
        }
      }
    }
  },
  "screen": {
    "s": {
      "value": "0px",
      "original": {
        "value": "0px"
      },
      "name": "ScreenS",
      "attributes": {
        "category": "screen",
        "type": "s"
      },
      "path": [
        "screen",
        "s"
      ]
    },
    "s-medium": {
      "value": "320px",
      "original": {
        "value": "320px"
      },
      "name": "ScreenSMedium",
      "attributes": {
        "category": "screen",
        "type": "s-medium"
      },
      "path": [
        "screen",
        "s-medium"
      ]
    },
    "s-large": {
      "value": "360px",
      "original": {
        "value": "360px"
      },
      "name": "ScreenSLarge",
      "attributes": {
        "category": "screen",
        "type": "s-large"
      },
      "path": [
        "screen",
        "s-large"
      ]
    },
    "s-xlarge": {
      "value": "390px",
      "original": {
        "value": "390px"
      },
      "name": "ScreenSXlarge",
      "attributes": {
        "category": "screen",
        "type": "s-xlarge"
      },
      "path": [
        "screen",
        "s-xlarge"
      ]
    },
    "m": {
      "value": "680px",
      "original": {
        "value": "680px"
      },
      "name": "ScreenM",
      "attributes": {
        "category": "screen",
        "type": "m"
      },
      "path": [
        "screen",
        "m"
      ]
    },
    "m-medium": {
      "value": "769px",
      "original": {
        "value": "769px"
      },
      "name": "ScreenMMedium",
      "attributes": {
        "category": "screen",
        "type": "m-medium"
      },
      "path": [
        "screen",
        "m-medium"
      ]
    },
    "l": {
      "value": "1024px",
      "original": {
        "value": "1024px"
      },
      "name": "ScreenL",
      "attributes": {
        "category": "screen",
        "type": "l"
      },
      "path": [
        "screen",
        "l"
      ]
    },
    "l-medium": {
      "value": "1100px",
      "original": {
        "value": "1100px"
      },
      "name": "ScreenLMedium",
      "attributes": {
        "category": "screen",
        "type": "l-medium"
      },
      "path": [
        "screen",
        "l-medium"
      ]
    },
    "xl": {
      "value": "1280px",
      "original": {
        "value": "1280px"
      },
      "name": "ScreenXl",
      "attributes": {
        "category": "screen",
        "type": "xl"
      },
      "path": [
        "screen",
        "xl"
      ]
    },
    "xl-medium": {
      "value": "1440px",
      "original": {
        "value": "1440px"
      },
      "name": "ScreenXlMedium",
      "attributes": {
        "category": "screen",
        "type": "xl-medium"
      },
      "path": [
        "screen",
        "xl-medium"
      ]
    },
    "xl-large": {
      "value": "1680px",
      "original": {
        "value": "1680px"
      },
      "name": "ScreenXlLarge",
      "attributes": {
        "category": "screen",
        "type": "xl-large"
      },
      "path": [
        "screen",
        "xl-large"
      ]
    },
    "xxl": {
      "value": "1920px",
      "original": {
        "value": "1920px"
      },
      "name": "ScreenXxl",
      "attributes": {
        "category": "screen",
        "type": "xxl"
      },
      "path": [
        "screen",
        "xxl"
      ]
    }
  }
};